{
  "app": {
    "title": "Диспечерски пулт",
    "loading": "Зареждане…",
    "signOut": "Изход",
    "offline": "Няма връзка · свързване…",
    "offlineHint": "Картата и опашката не се обновяват. Конзолата се свързва отново сама.",
    "newBuild": "Има нова версия на конзолата. При презареждане оставате влезли.",
    "newBuildLater": "По-късно",
    "reload": "Презареди",
    "stopped": "Нещо се обърка и конзолата спря. При презареждане оставате влезли."
  },
  "signIn": {
    "title": "Вход",
    "company": "Фирма",
    "companyHint": "Кодът на вашата фирма",
    "email": "Имейл",
    "password": "Парола",
    "submit": "Влез",
    "working": "Влизане…"
  },
  "queue": {
    "title": "Опашка",
    "empty": "Няма чакащи поръчки.",
    "reference": "Номер",
    "pickup": "Адрес",
    "state": "Статус",
    "waiting": "Чакане",
    "driver": "Шофьор",
    "minutes": "{{minutes}} мин",
    "dueIn": "след {{minutes}} мин",
    "automation": "Автоматично",
    "needsAttention": "Изисква ви",
    "needsAttentionHelp": "Търсенето се отказа или поръчка наближава без никой да е тръгнал.",
    "byHand": "На ръка",
    "searching": "Търси шофьор",
    "offeredTo": "При {{name}}, опит {{attempt}}",
    "offeredToMany": "При {{count}} шофьори на стоянката",
    "takeOver": "Поеми",
    "handBack": "Върни",
    "stage": {
      "Rank": "стоянката",
      "Zone": "зоната",
      "ParentZones": "по-широка зона",
      "Radius": "наблизо"
    },
    "needing_one": "{{count}} чака теб",
    "needing_other": "{{count}} чакат теб",
    "showOnMap": "Покажи на картата — {{name}}"
  },
  "order": {
    "newOrder": "Нова поръчка",
    "phone": "Телефон",
    "editPhone": "Промени номера",
    "noPhone": "без номер",
    "name": "Име",
    "pickup": "Адрес на качване",
    "destination": "Дестинация",
    "notes": "Бележки",
    "take": "Пусни поръчката",
    "taking": "Пускане…",
    "taken": "Поръчка {{reference}} е приета",
    "known": "Познат клиент · {{count}} пътувания",
    "savedAddresses": "Запазени адреси",
    "blocked": "Този клиент е блокиран",
    "pickupRequired": "Изберете адрес от списъка",
    "detail": "Поръчка {{reference}}",
    "history": "История",
    "close": "Затвори",
    "cancel": "Откажи поръчката",
    "destinationNotFound": "Дестинацията не бе намерена",
    "rating": "Оценка",
    "ratingStars_one": "{{count}} звезда",
    "ratingStars_other": "{{count}} звезди",
    "farePaid": "Платено",
    "fareEstimated": "Приблизителна цена",
    "scheduledFor": "За по-късно (по избор)",
    "title": "Поръчка",
    "keysHint": "Как се приема поръчка само с клавиатурата",
    "keysHelp": {
      "intro": "Цялата поръчка се приема без мишката:",
      "tab": "към следващото поле",
      "arrows": "в предложенията под адреса — избира; [Enter] го взема",
      "letter": "адрес с входове (напр. „4 входа“) — след [Enter] под полето излизат буквите им; натиснете нужната:",
      "letterDoor": "вход {{letter}}",
      "letterKeep": "[Enter] или [Esc] — без вход, колата отива до сградата",
      "letterNew": "друга буква — записва се като нов вход",
      "letterKey": "Буква",
      "scope": "само докато сте в поле за адрес — бутоните на „Търси в“:",
      "space": "включва или изключва изискване — може и няколко; между тях се минава с [Tab]",
      "spaceKey": "Интервал",
      "enter": "приема поръчката",
      "esc": "изчиства формата",
      "after": "След приета поръчка курсорът е вече в адреса за качване — следващата започва направо оттам."
    },
    "notesPlaceholder": "Каквото шофьорът трябва да знае",
    "holdCaller": "Задръж клиента",
    "customerPhone": "Телефон на клиента",
    "driver": "Шофьор",
    "call": "Обади се",
    "couldNotCall": "Обаждането не можа да се осъществи.",
    "noDriverPhone": "без телефон",
    "scope": {
      "label": "Търси в",
      "town": "Град",
      "nearby": "Околия",
      "wider": "Регион",
      "anywhere": "Навсякъде",
      "shortcut": "Alt+{{key}}",
      "nothingIn": "Нищо в „{{level}}“.",
      "auto": "Авто",
      "nothing": "Нищо не е намерено.",
      "widen": "Търси в „{{level}}“",
      "autoAbout": "Автоматично: първо в града, по-далеч само ако нищо не е намерено"
    },
    "mapMissing": "Търсенето в картата не отговаря — показват се само адресите на фирмата и на клиента.",
    "knownNamed": "Познат клиент: {{name}} · {{count}} пътувания",
    "replay": "Възпроизведи",
    "replayHelp": "Вижте пътуването на поръчката на картата — от момента, в който шофьор я е поел",
    "declineReason": {
      "too_far": "твърде далече",
      "finishing_shift": "приключва смяната",
      "break": "в почивка",
      "vehicle_problem": "проблем с колата",
      "other": "друга причина",
      "no_response": "не отговори навреме"
    },
    "reason": {
      "declinedBecause": "отказа — {{why}}",
      "declined": "отказа",
      "offerExpired": "предложението изтече",
      "reassigned": "взета от шофьора",
      "claimed": "прие първи от няколко",
      "noCars": "нямаше свободна кола",
      "needsHuman": "автоматичното разпределяне поиска диспечер",
      "atRisk": "предварителната поръчка е застрашена: още няма кола",
      "takenByHand": "поета ръчно",
      "automaticResumed": "върната на автоматичното разпределяне",
      "streetRide": "взета от улицата",
      "cancelledByRider": "Отказана от пътника: {{why}}",
      "cancelledByRiderOwnReason": "Отказана от пътника с причина от списъка на фирмата"
    },
    "driverRating": "Оценка от шофьора",
    "entrances": {
      "count_one": "{{count}} вход",
      "count_other": "{{count}} входа",
      "label": "Вход:",
      "keys": "буква — входът · Enter — цялата сграда",
      "waiting": "чака одобрение",
      "waitingAbout": "Поставен или преместен от диспечер или шофьор; вече се ползва и чака администратора",
      "reported": "сигнал",
      "reportedAbout": "Шофьор е отбелязал мястото като грешно; администраторът още не е отговорил",
      "unplaced": "нов вход",
      "unplacedAbout": "Никой още не е поставил този вход: колата отива до сградата, а шофьорът ще бъде питан дали да запомни мястото"
    },
    "numbers": {
      "count_one": "{{count}} номер",
      "count_other": "{{count}} номера"
    }
  },
  "assign": {
    "title": "Възложи на шофьор",
    "reassign": "Смени шофьора",
    "refresh": "Обнови",
    "more": "Още {{count}}",
    "fewer": "По-малко",
    "assign": "Възложи",
    "assigning": "Възлагане…",
    "holding": "Възложена",
    "noneAvailable": "Няма свободни шофьори наблизо",
    "stale": "преди {{seconds}} с",
    "staleHint": "Позицията е стара — колата може вече да не е там"
  },
  "map": {
    "title": "Автомобили на живо",
    "unavailable": "Картата не е достъпна в момента",
    "callSign": "Кратък номер",
    "arriving": "Пристига",
    "arrivingIn": "след около {{minutes}} мин",
    "vehicle": "Автомобил",
    "state": "Състояние",
    "onOrder": "На поръчка",
    "home": {
      "sectionTitle": "Къде се отваря всяка карта",
      "sectionHelp": "Преместете и приближете, докато картата покаже града ви както искате да го виждате, и запазете. Диспечерската карта и приложението за пътници се отварят тук — първо на позицията на пътника, тук когато телефонът не знае къде е — а редакторът на зони също, докато не е начертана първата зона; после се отваря върху самите зони. Търсенето на адреси също гледа първо около тази точка, така че улица, въведена без град, се намира във вашия град.",
      "search": "Намерете място по име — град, улица — и натиснете Enter",
      "notFound": "Нищо не е намерено за „{{query}}“.",
      "couldNotSearch": "Търсенето не успя.",
      "useThisView": "Използвай този изглед",
      "clearChoice": "Забрави избора ми",
      "unsaved": "Картата е преместена.",
      "saved": "Запазено. Всяка карта вече се отваря тук.",
      "figures": "{{latitude}}, {{longitude}} · мащаб {{zoom}}",
      "source": {
        "set": "Вие избрахте този изглед — или е зададен при създаването на фирмата от нейния град.",
        "derived": "Предположен от най-голямата ви зона. Преместете картата, за да го промените.",
        "deployment": "Още нищо не е избрано: това е изгледът по подразбиране на инсталацията. Преместете картата до града си и запазете.",
        "nowhere": "Още нищо не е избрано, затова картата се отваря над Европа. Намерете града си и запазете.",
        "moved": "Преместена. Запазете, за да се отваря всяка карта тук, или отхвърлете."
      },
      "sourceWord": {
        "set": "Избран от страницата Карта",
        "derived": "Взет от най-голямата ви зона"
      },
      "guide": {
        "title": "Къде сте",
        "body": "Преместете картата до града си както искате да го виждате; всяка карта ще се отваря тук. Оставите ли я, по-късно се предполага от зоните ви."
      }
    },
    "toggleOnBreak": "Показва или скрива колите в почивка",
    "allowedCars": "Може да кара",
    "headingHome": "Пътува към дома",
    "headingTo": "Пътува към {{address}}",
    "headingHomeHint": "Получава само поръчки, чиято крайна точка го приближава натам, накъдето пътува."
  },
  "settings": {
    "title": "Настройки на диспечирането",
    "close": "Затвори",
    "save": "Запази",
    "saving": "Запазване…",
    "saved": "Запазено",
    "couldNotLoad": "Настройките не можаха да се заредят. Възможно е да нямате права да ги променяте.",
    "couldNotSave": "Настройките не можаха да бъдат запазени.",
    "unitSeconds": "секунди",
    "unitDrivers": "шофьори",
    "autoDispatch": "Автоматично изпращане на коли",
    "autoDispatchHelp": "Поръчките сами намират шофьор, вместо да чакат диспечер. Диспечерите могат да възлагат ръчно по всяко време.",
    "dispatchIntervalSeconds": "Проверявай опашката на всеки",
    "dispatchIntervalSecondsHelp": "Колко често се преглеждат чакащите поръчки. По-малко означава по-бързо за пътника; рядко има причина да е над десет.",
    "offerTimeoutSeconds": "Шофьорът трябва да отговори до",
    "offerTimeoutSecondsHelp": "След това предложението се оттегля и отива при следващия шофьор. Твърде кратко и шофьорът не успява да вземе телефона; твърде дълго и пътникът чака някой, който не гледа.",
    "maxDispatchAttempts": "Опитай най-много при",
    "maxDispatchAttemptsHelp": "На колко шофьори може да бъде предложена една поръчка, преди търсенето да се откаже.",
    "searchTimeoutSeconds": "Откажи търсенето след",
    "searchTimeoutSecondsHelp": "Ограничение във време, освен по брой шофьори, за да не чака вечно поръчка, която никой не е бил свободен да откаже. 0 означава само по брой шофьори.",
    "whenNoCarsFound": "Когато няма намерена кола",
    "whenNoCarsFoundHelp": "Какво се случва, след като търсенето се откаже.",
    "noCarsAction": {
      "TellTheRider": "Уведоми пътника и отмени",
      "EscalateToDispatcher": "Остави я за диспечер"
    },
    "retryAfterSeconds": "Помоли пътника да опита отново след",
    "retryAfterSecondsHelp": "Показва се при отмяна на пътуването. Достатъчно дълго, за да се е сменил съставът на колите, и достатъчно кратко, за да е още наблизо.",
    "unitMetres": "метра",
    "unitMetresPerMinute": "метра на минута",
    "unitMinutes": "минути",
    "unitDays": "дни",
    "moveUp": "Нагоре",
    "moveDown": "Надолу",
    "removeStage": "Премахни тази стъпка",
    "addStage": "Използвай тази стъпка",
    "groupLadder": "Кого питаме и в какъв ред",
    "groupLadderHelp": "Поръчката се предлага навън на стъпки. Всяка стъпка се изчерпва преди следващата, а стъпка без никого в нея се прескача, вместо да се чака.",
    "dispatchRadiiMetres": "Разширяващи се кръгове",
    "dispatchRadiiMetresHelp": "Разстояния от адреса на качване, в метри, опитвани поред след като зоните свършат. Разделяйте ги със запетаи. Последното е най-далеч, докъдето сте склонни да пратите кола.",
    "stage": {
      "Rank": "Стоянката",
      "RankHelp": "Стоянката, покриваща адреса. Първият в опашката е питан сам; всички останали на тази стоянка са питани заедно след него.",
      "Zone": "Зоната",
      "ZoneHelp": "Шофьорите в зоната, в която е адресът на качване.",
      "ParentZones": "Зоните над нея",
      "ParentZonesHelp": "Всяка по-голяма зона поред — районът, после градът.",
      "Radius": "Разширяващи се кръгове",
      "RadiusHelp": "Всеки в рамките на всяко разстояние поред. Тази стъпка работи и когато не са начертани зони."
    },
    "groupRanks": "Стоянки",
    "groupRanksHelp": "Стоянката е зона, на която шофьорите чакат на опашка. Редът на пристигане решава кой е питан пръв — правилото, по което стоянките работят открай време.",
    "rankFirstOfferSeconds": "Първата кола има",
    "rankFirstOfferSecondsHelp": "Колко време първият в опашката получава поръчката само за себе си. Той е чакал най-дълго и има право на пръв отказ, затова времето е по-дълго от това на останалите.",
    "rankRestOfferSeconds": "Останалите после имат",
    "rankRestOfferSecondsHelp": "Ако първата кола не я вземе, останалите на стоянката са питани едновременно и първият приел печели. По-кратко, защото пътник чака.",
    "rankExitMarginMetres": "Колата пази реда си до",
    "rankExitMarginMetresHelp": "Колко навън от стоянката може да се отклони кола, преди да загуби реда си. Позицията на паркирана кола се лута с десетки метри и без този допуск тя би се връщала най-отзад всяка минута.",
    "groupFairness": "Справедливост",
    "groupFairnessHelp": "Най-близкият не е целият отговор. Тези стойности променят на какво разстояние се смята един шофьор, в метри, за да може да му се обясни: отказите го отдалечават, чакането го приближава.",
    "acceptancePenaltyMetres": "Постоянните откази струват",
    "acceptancePenaltyMetresHelp": "С колко по-далеч се смята шофьор, който никога не приема. Дръжте го умерено: тежкото наказание учи шофьорите да приемат и после да отказват, което е по-лошо за пътника.",
    "idleBonusMetresPerMinute": "Всяка минута чакане носи",
    "idleBonusMetresPerMinuteHelp": "С колко по-близо изглежда шофьор за всяка минута чакане на смяна, за да не бъде тихият край на града задънена улица.",
    "maxFairnessAdjustmentMetres": "Не местѝ шофьор с повече от",
    "maxFairnessAdjustmentMetresHelp": "Таванът на двете настройки по-горе. След него разстоянието решава, каквото и да е досието — това пази кола да не бъде пращана през целия град, докато по-близка чака.",
    "acceptanceWindowDays": "Брой последните",
    "acceptanceWindowDaysHelp": "Колко история влиза в процента приети поръчки. Поръчки, спечелени по-рано от друг шофьор, не се броят срещу никого.",
    "roadRankingCandidates": "Провери по път за",
    "roadRankingCandidatesHelp": "На колко от най-близките шофьори се проверява разстоянието по път, а не по права линия, за да не изглежда близо онзи от другата страна на реката. Всяка проверка се таксува от доставчика на карти.",
    "groupPreBookings": "Поръчки за по-късно",
    "groupPreBookingsHelp": "Поръчка за утре сутрин не бива да стои в тазвечерната опашка, но и не бива да се търси кола чак в часа на качване.",
    "preBookingLeadMinutes": "Започни да търсиш",
    "preBookingLeadMinutesHelp": "Колко преди часа на качване започва търсенето на шофьор. Твърде късно и колата закъснява; твърде рано и шофьор чака неплатен пред адреса.",
    "preBookingEscalateMinutes": "Предупреди офиса",
    "preBookingEscalateMinutesHelp": "Колко преди качването незаета поръчка се отбелязва в опашката. Курс до летището в четири сутринта, за който няма никой, е случаят, заради който съществува това.",
    "loading": "Зарежда се…",
    "unsaved_one": "{{count}} незапазена промяна",
    "unsaved_other": "{{count}} незапазени промени",
    "discard": "Откажи промените",
    "cancel": "Откажи",
    "groupSending": "Изпращане на коли",
    "groupSendingHelp": "Времената, които решават колко бързо пътникът получава отговор и колко дълго шофьорът има да отговори.",
    "preBookingsEnabled": "Приемай поръчки за по-късно",
    "preBookingsEnabledOn": "Формулярът за поръчка има поле „За по-късно“, а заявените за по-късно стоят отделно, докато дойде часът им.",
    "preBookingsEnabledOff": "Всяка поръчка е за сега: формулярът няма поле „За по-късно“ и приложението за пътници не може да заяви предварително. Вече заявените за по-късно пак се изпълняват."
  },
  "admin": {
    "title": "Настройки на фирмата",
    "sections": "Раздели с настройки",
    "tab": {
      "dispatch": "Разпределяне",
      "zones": "Зони и стоянки",
      "tariffs": "Цени",
      "surcharges": "Нощна, празници",
      "telephony": "Телефони",
      "duty": "Дни и ставки",
      "reports": "Справки",
      "branding": "Оформление",
      "import": "Клиенти от предишната ви система",
      "fleet": "Автопарк",
      "simulation": "Симулация"
    }
  },
  "simulation": {
    "title": "Симулация на {{city}}",
    "hint": "Тази фирма не е истинска. Шофьорите ѝ са процеси, поръчките пристигат сами, а клиентите са измислени. Нищо от това не съществува на работещ сървър.",
    "notRunning": "Фирмата е отбелязана като симулирана, но за нея не работи симулация. Проверете дневника на сървъра: обичайната причина е код на фирма, за който няма зададен град.",
    "couldNotChange": "Симулацията не можа да бъде променена.",
    "drivers": "Шофьори",
    "running": "Работи",
    "runningHint": "При изключване всеки симулиран шофьор излиза от смяна, вместо да остане замръзнал на картата.",
    "activeDrivers": "Шофьори на смяна",
    "activeDriversHint": "От петдесет. Влизат в смяна, подават позиция и приемат работа като всички останали.",
    "outsideCity": "Шофьори извън града",
    "outsideCityHint": "Колко от тях се движат извън {{city}}, към реални места наблизо.",
    "acceptProbability": "Колко често шофьор приема",
    "acceptProbabilityHint": "Между 0 и 1. Под единица, за да има откази и каскадата от предложения да се използва.",
    "work": "Работа",
    "ordersPerHour": "Поръчки на час",
    "ordersPerHourHint": "Правят се от заредените клиенти, от адресите, които обикновено ползват. Нула спира новите; започнатите пътувания завършват.",
    "callsPerHour": "Обаждания на час",
    "callsPerHourHint": "Част се вдигат, останалите отиват в списъка с пропуснати. Нула ги спира.",
    "createOrders": "Пет поръчки веднага",
    "callerLabel": "Кой се обажда",
    "caller": {
      "known": "Познат клиент",
      "unknown": "Непознат номер",
      "withheld": "Скрит номер"
    },
    "ring": "Обади се",
    "reset": "Изчисти",
    "noAudio": "Симулираното обаждане показва картона на клиента и запис в дневника. Няма звук и софтуерният телефон няма да звъни — за това е нужна истинската телефонна система.",
    "counters": "От пускането",
    "ordersCreated": "{{count}} поръчки приети",
    "ridesCompleted": "{{count}} пътувания завършени",
    "ridesNoShow": "{{count}} клиенти не излязоха",
    "offersAccepted": "{{count}} предложения приети",
    "offersDeclined": "{{count}} предложения отказани",
    "callsRung": "{{count}} обаждания подадени",
    "callsMissed": "{{count}} обаждания пропуснати",
    "fleet": "В момента на смяна",
    "away": "извън града",
    "column": {
      "callSign": "№",
      "driver": "Шофьор",
      "plate": "Кола",
      "phase": "Прави",
      "order": "Пътуване"
    },
    "phase": {
      "SignedOff": "Извън смяна",
      "Roaming": "Обикаля",
      "Considering": "Гледа предложение",
      "ToPickup": "Пътува към клиента",
      "WaitingAtPickup": "Чака пред адреса",
      "OnRide": "Вози пътник",
      "Break": "В почивка",
      "Retiring": "Довършва и излиза"
    }
  },
  "tariffs": {
    "history": "История на цените",
    "historyHelp": "Всяка версия с датите, на които е важала. Старите версии са само за четене: сумите, които са произвели, са това, което хората са платили.",
    "none": "Още няма зададени цени.",
    "code": "Тарифа",
    "from": "От",
    "to": "До",
    "inForce": "В сила",
    "fromTheStart": "От самото начало",
    "introduce": "Нови цени",
    "introduceHelp": "Това добавя нова версия, а не редактира текущата. Действащата се затваря в момента, в който новата започва, така че вече остойностените курсове запазват цените си.",
    "introduceAction": "Пусни тези цени в сила",
    "displayName": "Име",
    "displayNameHelp": "Как офисът нарича тази тарифа. Използва се само за четене.",
    "category": "Клас автомобил",
    "categoryHelp": "Всички класове се таксуват еднакво, освен ако не изберете един: комби или ван могат да имат своя цена. Екстрите като домашни любимци или инвалидна количка не струват допълнително.",
    "everyClass": "Всички класове",
    "baseFare": "Начална такса",
    "baseFareHelp": "Начислява се в момента на тръгване, независимо от разстоянието.",
    "perKilometre": "На километър",
    "perKilometreHelp": "За всеки изминат километър. И тази, и цената на минута важат едновременно, както работи истински таксиметров апарат.",
    "perMinute": "На минута",
    "perMinuteHelp": "За всяка минута от пътуването, за да не работи колата напразно в задръстване.",
    "perWaitingMinute": "На минута чакане",
    "perWaitingMinuteHelp": "Начислява се докато шофьорът чака на адреса, след безплатните минути по-долу.",
    "freeWaitingMinutes": "Безплатно чакане",
    "freeWaitingMinutesHelp": "Минути чакане, които се подаряват. Не е щедрост — пази пътника да не плаща за шофьор, дошъл по-рано.",
    "minimumFare": "Минимална сума",
    "minimumFareHelp": "Долната граница, колкото и кратък да е курсът. Без нея шофьорите отказват късите курсове.",
    "roundingIncrement": "Закръгляй до",
    "roundingIncrementHelp": "До какво се закръгля общата сума — 0.10 за най-близките десет стотинки, за да не брои шофьорът стотинки на тъмно.",
    "currency": "Валута",
    "currencyHelp": "Валутата на фирмата, вече попълнена. Сменете я само ако тази тарифа е в друга — три букви, например EUR.",
    "effectiveFrom": "В сила от",
    "effectiveFromHelp": "Кога започват тези цени. Оставете празно за веднага."
  },
  "fees": {
    "title": "Такси за отказ и за неявяване",
    "intro": "Какво начислява фирмата за пътуване, което не се е състояло. Нула означава, че не начислява нищо — оттам започва всяка фирма. За разлика от тарифата, това са обикновени числа, а не версии: сумата се записва върху поръчката в момента, в който възниква, така че промяна тук никога не може да достигне вече станал отказ.",
    "cancellation": "Такса за отказ ({{currency}})",
    "cancellationHelp": "Начислява се, когато пътник откаже пътуване, към което шофьор вече е тръгнал — не и когато поръчката още чака кола, нито когато предложението е при шофьор, който още не е отговорил. Ако зададете сума, приложението на пътника я посочва в предупреждението преди отказа; при нула то казва само, че фирмата може да начисли такса.",
    "noShow": "Такса за неявяване ({{currency}})",
    "noShowHelp": "Начислява се, когато колата е стигнала до адреса и никой не се е явил. Обикновено е по-висока от таксата за отказ: шофьор, чакал пред входа, е загубил повече от този, върнат по пътя.",
    "bothOff": "И двете са нула, така че не се начислява нищо нито за отказ, нито за неявяване. Приложението на пътника запазва общото предупреждение, че фирмата може да начисли такса."
  },
  "payment": {
    "title": "Как се плащат пътуванията",
    "intro": "Шофьорите не биват питани как е платено пътуването, затова всяко завършено пътуване се записва по този начин, освен ако не е посочено друго. Това пълни колоната „в брой“ в книгата на смените: преди него всяко пътуване попадаше в „без отчитане“ и половината от отчета за оборота не казваше нищо.",
    "fallback": "Записвай пътуването като",
    "fallbackHelp": "Прилага се при завършване на пътуване, за което не е казано нищо за плащането. Ако шофьор все пак посочи как е платено, важи неговият отговор.",
    "method": {
      "Cash": "В брой",
      "Card": "С карта",
      "Account": "По сметка",
      "none": "Не записвай нищо"
    },
    "recordingNothing": "Няма да се записва нищо и завършените пътувания ще продължат да се броят като неотчетени в книгата на смените. Изберете това, ако колите ви приемат карта толкова често, колкото и брой — допускане, което е грешно в половината случаи, е по-лошо от признат пропуск.",
    "neverBackwards": "Вече завършените пътувания остават точно както са. Никой не е бил питан как са платени, затова колоната им остава празна, вместо да получат отговор със задна дата."
  },
  "surcharges": {
    "rules": "Нощна и празнична тарифа",
    "rulesHelp": "Нощна или празнична тарифа със собствени цени — началната такса, километърът, минутата и чакането, всяко поотделно, както е в апарата — или надбавка с процент и сума върху стандартната тарифа.",
    "noRules": "Няма зададени нощни или празнични тарифи.",
    "calendar": "Календар с празници",
    "calendarHelp": "Кои дати се броят за празници за тази фирма. Българските празници не са ирландските, затова този календар е само ваш.",
    "noHolidays": "Няма зададени празници.",
    "kindLabel": "Важи",
    "kindLabelHelp": "В определени часове от определени дни или на датите от вашия календар с празници.",
    "kind": {
      "TimeBand": "В определени часове",
      "Holiday": "На празници"
    },
    "code": "Кратко име",
    "codeHelp": "Постоянно име, използвано в справките, например night.",
    "name": "Показва се като",
    "nameHelp": "Каквото пише на касовата бележка на пътника. Вашите думи, на вашия език.",
    "hours": "Между",
    "hoursHelp": "По вашето местно време. Край по-рано от началото значи, че минава през полунощ — както обикновено се пише нощна тарифа.",
    "until": "До",
    "days": "В тези дни",
    "day": {
      "Monday": "пн",
      "Tuesday": "вт",
      "Wednesday": "ср",
      "Thursday": "чт",
      "Friday": "пт",
      "Saturday": "сб",
      "Sunday": "нд"
    },
    "percentField": "Добави процент",
    "percentFieldHelp": "Процент от това, което е направил апаратът. Взема се върху сумата по апарат, така че две правила по десет процента дават двадесет, а не двадесет и едно.",
    "amountField": "Добави фиксирана сума",
    "amountFieldHelp": "Плоска сума във валутата на тарифата. Може да зададете и процент, и сума.",
    "active": "Активно",
    "activeHelp": "Изключете правило, без да го губите.",
    "saveRule": "Запази тази тарифа",
    "cancelEdit": "Откажи",
    "edit": "Редактирай",
    "remove": "Премахни",
    "band": "{{from}} до {{to}}",
    "onHolidays": "На празници",
    "percent": "+{{percent}}%",
    "amount": "+{{amount}}",
    "everyYear": "всяка година на {{date}}",
    "holidayName": "Име",
    "holidayNameHelp": "Как се казва денят.",
    "holidayDate": "Дата",
    "holidayDateHelp": "За повтаряща се дата годината се пренебрегва.",
    "recurring": "Същата дата всяка година",
    "recurringHelp": "Коледа се повтаря; Великден — не. Подвижна дата се въвежда всяка година.",
    "saveHoliday": "Запази тази дата",
    "addRule": "Добави тарифа",
    "editRule": "Редактиране на тарифа",
    "addHoliday": "Добави дата",
    "editHoliday": "Редактиране на дата",
    "uplift": "Цени",
    "allDays": "Всеки ден",
    "inactive": "Неактивно",
    "confirmRemoveRuleTitle": "Да премахна ли тази тарифа?",
    "confirmRemoveRule": "{{name}} ще бъде премахната. Вече повишените курсове остават както са били таксувани. Това не може да се отмени.",
    "confirmRemoveHolidayTitle": "Да премахна ли тази дата?",
    "confirmRemoveHoliday": "{{name}} вече няма да се брои за празник. Това не може да се отмени.",
    "modeLabel": "Как се таксува",
    "modeHelp": "Собствени цени заместват тези на стандартната тарифа за целия курс — така се задава нощна тарифа в България. Надбавката добавя процент или сума върху цените на стандартната тарифа.",
    "mode": {
      "Rates": "Собствени цени",
      "Uplift": "Надбавка върху стандартната"
    },
    "ownPrices": "старт {{base}} · {{perKilometre}}/км"
  },
  "zones": {
    "tree": "Зони",
    "treeHelp": "Вашата карта на града: райони, а в тях стоянки. Едни и същи зони решават колко струва курсът и на кого се предлага. Влагат се на три нива.",
    "overview": "На картата",
    "overviewAbout": "Всяка зона, където е. Щракнете върху нея, върху името ѝ или върху бутона ѝ отдолу, за да я редактирате.",
    "overviewHelp": "Всяка зона в свой цвят, различен от зоната, в която е, и от съседната. Квадратчетата са райони, кръгчетата — стоянки. Изключена зона е избледняла.",
    "expand": "Картата на цялата страница",
    "shrink": "Картата отново малка",
    "snapHelp": "Щракнете близо до връх или страна на съседна зона и върхът ляга точно върху нея, така че двете се допират без междина. Върховете им се показват като малки кръгчета, докато показалецът е върху картата.",
    "keepCorners": "Върховете на съседите винаги",
    "keepCornersHelp": "Показват се, докато показалецът е върху картата — достатъчно при редакция на съществуваща зона. При чертане на нова някои предпочитат да виждат върховете на съседите постоянно, защото именно там се целят новите върхове.",
    "keepCornersHint": "За какво е този превключвател",
    "none": "Няма начертани зони.",
    "rank": "стоянка",
    "circleOf": "кръг, {{radius}} м",
    "polygonOf": "граница, {{corners}} върха",
    "charges": "+{{percent}}% +{{amount}}",
    "add": "Добави зона",
    "editing": "Редактиране на {{name}}",
    "code": "Кратко име",
    "codeHelp": "Постоянно име, използвано в справките, например airport.",
    "name": "Показва се като",
    "nameHelp": "Как офисът я нарича.",
    "hue": "Цвят",
    "hueHelp": "С какъв цвят се рисува зоната на картите. Автоматичният я отличава от зоните, в които е, до които е или които докосва; изберете цвят, ако две съседни пак си приличат.",
    "hueAutomatic": "Автоматичен",
    "hueNumber": "Цвят {{number}}",
    "parent": "Вътре в",
    "parentHelp": "По-голямата зона, в която се намира тази. Оставете празно за зона от най-горно ниво, например самия град.",
    "noParent": "Никъде — зона от най-горно ниво",
    "kindLabel": "Тази зона е",
    "kindLabelHelp": "Стоянката поддържа опашка от паркираните на нея шофьори и първият в опашката получава поръчка пръв.",
    "kind": {
      "Area": "Район",
      "Rank": "Стоянка"
    },
    "shapeLabel": "Форма",
    "shapeLabelHelp": "Кръгът е три числа и покрива стоянка или терминал. Чертайте граница, когато кръгът би хванал грешната страна на улицата.",
    "shape": {
      "Circle": "Кръг",
      "Polygon": "Начертана граница"
    },
    "radius": "Радиус",
    "radiusHelp": "Докъде стига кръгът от центъра си. Плъзнете плъзгача или въведете метрите.",
    "radiusValue": "{{metres}} метра",
    "clickCentre": "Щракнете на картата, за да поставите центъра, или го влачете.",
    "clickCorners": "Щракайте на картата, за да добавяте върхове по реда на границата. Щракнете върху страна, за да добавите връх на нея, и влачете връх, за да го преместите.",
    "undo": "Върни",
    "clearCorners": "Започни отначало",
    "surchargePercent": "Добави процент",
    "surchargePercentHelp": "Процент, добавян към курсове, докосващи тази зона. Оставете нула за зона, която само организира картата.",
    "surchargeAmount": "Добави фиксирана сума",
    "surchargeAmountHelp": "Плоска сума, добавяна към курсове, докосващи тази зона — обикновено летищната надбавка.",
    "appliesTo": "Начислява се при",
    "appliesToHelp": "Кой край на пътуването трябва да е в тази зона. Начислява се веднъж дори когато и двата са.",
    "trigger": {
      "Pickup": "Качване тук",
      "Destination": "Слизане тук",
      "Either": "Който и да е край"
    },
    "active": "Активна",
    "activeHelp": "Изключете зона, без да триете курсовете, които е остойностила.",
    "save": "Запази тази зона",
    "ranks": "Стоянки",
    "ranksHelp": "Местата, където шофьорите чакат работа. Стоянката поддържа опашка по реда на пристигане и първият в опашката получава поръчка пръв.",
    "noRanks": "Няма начертани стоянки.",
    "addRank": "Добави стоянка",
    "off": "Изключена",
    "columnZone": "Зона",
    "columnSurcharge": "Надбавка",
    "confirmRemoveTitle": "Да премахна ли тази зона?",
    "confirmRemove": "{{name}} ще бъде премахната, а всеки курс, който е остойностила или разпределила, запазва полученото. Това не може да се отмени."
  },
  "addressSearch": {
    "levels": "Три нива",
    "levelsHelp": "Всяко е кръг или очертана област и включва нивата над себе си. Всяка поръчка започва с търсене в града.",
    "columnLevel": "Ниво",
    "level": {
      "Town": "Град",
      "Nearby": "Околия",
      "Wider": "Регион"
    },
    "levelAbout": {
      "Town": "Тук диспечерът търси по подразбиране. Очертайте самия град.",
      "Nearby": "Селата, до които фирмата вози. Търси се заедно с града, когато диспечерът превключи на него.",
      "Wider": "Още по-далеч, например летището в съседния град. Ако не е очертано, това ниво търси навсякъде."
    },
    "notDrawn": "Не е очертано",
    "anywhere": "Не е очертано: търси навсякъде",
    "draw": "Очертай",
    "clear": "Изчисти",
    "editing": "{{level}}: къде се търси",
    "copyFrom": "Започни от зона",
    "copyFromHelp": "Копира формата на зоната. Ако по-късно промените зоната, това не се променя.",
    "copyChoose": "Изберете зона…",
    "shapeHelp": "Кръгът е най-бърз. Очертайте област, когато кръгът би обхванал места, които фирмата не обслужва.",
    "radiusHelp": "Колко далеч от центъра може да е адресът.",
    "overview": "На картата",
    "overviewAbout": "Очертаните досега нива. Щракнете върху някое, за да го промените.",
    "nothingDrawn": "Още нищо не е очертано. Диспечерът търси навсякъде, като най-близките са първи, и няма превключвател, докато не очертаете града.",
    "confirmClearTitle": "Да се изчисти ли нивото?",
    "confirmClear": "Диспечерът вече няма да търси в „{{level}}“ като отделно ниво.",
    "confirmClearWider": "Най-широкото ниво отново ще търси навсякъде.",
    "overviewHelp": "Всяко ниво в свой цвят. Легендата ги назовава; щракнете върху някое, за да го промените.",
    "save": "Запази",
    "rider": {
      "title": "Търсене в приложението за пътници",
      "help": "Кой намира адреса, който пътникът пише в приложението, и назовава мястото под карфицата. Адресите на фирмата винаги излизат първи, каквото и да е избрано. Бюрото и приложението за шофьори винаги търсят в нашите карти: условията на Google позволяват резултатите му само върху картата на Google, която приложението за пътници използва, а те — не.",
      "supplier": "Търси с",
      "about": {
        "OwnMaps": "Нашите собствени карти на България, същите като на бюрото.",
        "Google": "Google, за улици, които нашите карти нямат."
      },
      "googleUnavailable": "Google не може да бъде избран: тази инсталация няма ключ за Google.",
      "googleFallenBack": "Тази инсталация няма ключ за Google, затова приложението за пътници търси в нашите карти, докато не бъде добавен.",
      "suppliers": {
        "OwnMaps": "Нашите карти",
        "Google": "Google"
      }
    }
  },
  "prebookings": {
    "title": "Заявени за по-късно",
    "dueIn": "след {{minutes}} мин",
    "atRisk": "Няма шофьор",
    "atRiskHelp": "Търсенето изтече и никой не е тръгнал. Разпределете ръчно."
  },
  "telephony": {
    "title": "Телефонна централа",
    "enabled": "Тази фирма има телефонна централа",
    "enabledHelp": "Включете, след като централата е инсталирана и достъпна. Дотогава никакъв разговор не стига до конзолата и нищо не се записва.",
    "groupCalls": "Разговори",
    "groupCallsHelp": "Как конзолата стига до централата, за да вижда входящи разговори и да звъни. Без това няма нито изскачащ екран, нито звънене с един клик.",
    "groupExtensions": "Телефони на диспечерите",
    "groupExtensionsHelp": "Базата в централата, където живеят телефоните на диспечерите. Без нея никой не може да получи телефон, а вече влезлите спират да работят след няколко минути.",
    "groupNumbers": "Номера и линии",
    "groupNumbersHelp": "На кои номера се обаждат на фирмата и по коя линия излизат разговорите.",
    "groupRecording": "Записване",
    "groupRecordingHelp": "Дали разговорите се записват и колко дълго се пазят. Дали да записвате клиент е правно решение на фирмата, не наше.",
    "pbxBaseUrl": "Адрес на централата",
    "pbxBaseUrlHelp": "Къде отговаря централата, заедно с порта. Това никога не трябва да е достъпно от интернет — отворена централа прави международни разговори за ваша сметка.",
    "pbxAriUsername": "Потребител",
    "pbxAriUsernameHelp": "Акаунтът, с който конзолата следи и започва разговори.",
    "pbxAriSecret": "Парола",
    "pbxWebSocketUrl": "Адрес за телефона в браузъра",
    "pbxWebSocketUrlHelp": "Къде браузърът на диспечера се включва, за да води разговори. В платформата това е адресът на фирмата с pbx като втора дума — показан в сиво в празното поле — и платформата го предава на централата през тунела.",
    "pbxRealtimeHost": "Адрес на базата с телефоните",
    "pbxRealtimeHostHelp": "Самата машина на централата. Трябва да е нейната, защото централата я чете при всяко влизане на телефон — копие на друго място би направило телефоните зависими от интернета на офиса.",
    "pbxRealtimePort": "Порт",
    "pbxRealtimePortHelp": "Обикновено 5432.",
    "pbxRealtimeDatabase": "Име на базата",
    "pbxRealtimeDatabaseHelp": "Базата, от която централата чете телефоните си.",
    "pbxRealtimeUsername": "Потребител на базата",
    "pbxRealtimeUsernameHelp": "Акаунт, който може да добавя и маха телефони. Нищо повече.",
    "pbxRealtimePassword": "Парола на базата",
    "secretStored": "Има запазена парола. Оставете празно, за да я запазите.",
    "secretNotStored": "Все още няма запазена парола.",
    "inboundNumbers": "Номера на фирмата",
    "inboundNumbersHelp": "Разделени със запетаи. Разговорът се свързва с фирмата по номера, на който са звъннали, така че всеки номер трябва да е тук.",
    "outboundLineStrategy": "Изходящите разговори излизат по",
    "outboundLineStrategyHelp": "По коя линия излиза обратното обаждане — а оттам кой от вашите номера вижда клиентът.",
    "lineStrategy": {
      "ReturnPath": "Линията, по която е дошъл разговорът",
      "FirmOrder": "Нашите линии, в реда по-долу"
    },
    "outboundOrder": "Линии за изходящи разговори",
    "outboundOrderHelp": "Използва се първата свободна линия. Ако е заета, разговорът излиза по следващата и така надолу по списъка. Линиите извън списъка не се ползват за изходящи разговори.",
    "outboundOrderEmpty": "Изберете поне една линия по-долу, иначе настройката не може да се запази.",
    "outboundOrderNoLines": "Фирмата още няма линии. Добавете ги в „Линии“ по-долу, после изберете реда им тук.",
    "outboundOrderAdd": "Използвай тази линия",
    "outboundOrderRemove": "Спри да използваш тази линия",
    "recordCalls": "Записвай разговорите",
    "recordCallsHelp": "В началото на всеки записван разговор се пуска съобщение. Записване без предупреждение не е функция, а глоба.",
    "recordingRetentionDays": "Пази записите",
    "recordingRetentionDaysHelp": "След това се изтриват. Няма „пази всичко“: записите на клиент са лични данни, а архив без край е проблем, който чака първия попитал какво пазите за него.",
    "groupBlocked": "Блокирани клиенти",
    "groupBlockedHelp": "Какво става, когато звъни клиент, отбелязан като блокиран.",
    "turnBlockedCallersAway": "Отказвай блокираните",
    "turnBlockedCallersAwayHelp": "Блокираният клиент чува заето и нито един телефон не звъни. Разговорът остава в дневника като отказан. Ако системата не отговаря, разговорът звъни както обикновено.",
    "recordWithoutAnnouncement": "Записвай без съобщение",
    "recordWithoutAnnouncementHelp": "Разрешено на фирмата от оператора на платформата. Клиентът не чува нищо преди разговора; уведомете го по друг начин, както е договорено.",
    "recordWithoutAnnouncementOnRequest": "Може да се разреши от оператора на платформата, след като договорите как клиентите се уведомяват по друг начин. Дотогава съобщението се пуска.",
    "groupCallFlow": "Как клиентът чака колата",
    "groupCallFlowHelp": "Какво се случва с обаждащия се, след като диспечерът е приел поръчката. Не пипайте това, преди записите на съобщенията и вътрешният номер за изчакване да са настроени на централата.",
    "callFlow": "След като поръчката е приета",
    "callFlowHelp": "Класическият начин е това, което повечето фирми правят: диспечерът вдига, приема поръчката и разговорът приключва.",
    "flow": {
      "Classic": "Нищо — разговорът просто приключва",
      "HoldAndAnnounce": "Задръж клиента и му кажи коя кола идва",
      "RingBackOnly": "Затвори и позвъни обратно с колата"
    },
    "flowHelp": {
      "Classic": "Без музика на изчакване, без съобщение, без обратно позвъняване. Нищо по-долу не важи.",
      "HoldAndAnnounce": "Диспечерът оставя клиента на музика. Когато шофьор приеме поръчката, клиентът чува номера на колата и след колко минути пристига. Клиент, когото не бива да задържате — на SIM или при заети линии — получава обратно позвъняване вместо това.",
      "RingBackOnly": "Никой не чака на линия. Диспечерът приема поръчката, казва, че фирмата ще позвъни, и затваря; клиентът получава обаждане с номера на колата, щом шофьор приеме. Този вариант не заема линии."
    },
    "trunkChannels": "Едновременни разговори по интернет линията",
    "trunkChannelsHelp": "Това, което телекомът ви е продал, и което системата не може да измери. Сгрешено нагоре, клиентите чуват заето; сгрешено надолу, задържате по-малко хора, отколкото можете.",
    "trunkChannelsKeptFree": "Винаги свободни за нови обаждания",
    "trunkChannelsKeptFreeHelp": "Чакащият кола заема линия през цялото време. Без това фирма, задържала четирима на линия за четири разговора, е фирма, на която никой не може да се обади.",
    "maxHeldOnTrunk": "Остава място за {{count}} чакащ едновременно.",
    "maxHeldOnTrunk_other": "Остава място за {{count}} чакащи едновременно.",
    "simLinePattern": "SIM линиите се казват",
    "simLinePatternHelp": "Обаждане по линия, чието име започва с това, е дошло по SIM. Оставете празно, ако фирмата няма SIM карти. Колоната „линия“ в дневника на разговорите показва какви са имената в действителност.",
    "maxHeldOnSims": "Задържани на SIM едновременно",
    "maxHeldOnSimsHelp": "SIM картата е един разговор. Докато някой чака на нея, номерът е зает за всички останали — затова обичайният отговор е нула, а клиентът от SIM получава обратно позвъняване.",
    "holdTimeoutSeconds": "Задръж клиента най-много",
    "holdTimeoutSecondsHelp": "След това се случва избраното по-долу. Три минути е обичайният отговор.",
    "waitingReminderSeconds": "Казвай „още търсим“ на всеки",
    "waitingReminderSecondsHelp": "Пуска се върху музиката, за да знае чакащият, че линията е жива. Нула го изключва; иначе най-краткото е двадесет секунди.",
    "whenHoldExpires": "Когато е чакал толкова",
    "whenHoldExpiresHelp": "Нито едното не е приятно. Да затворите е допустимо само ако наистина позвъните обратно, а да го върнете на диспечер — само ако има свободен.",
    "holdExpiry": {
      "RingBackWhenCarFound": "Кажи, че ще позвъниш, затвори и го направи",
      "ReturnToDispatchers": "Звънни отново на диспечерите"
    },
    "ringBackWhenCallerHangsUp": "Звънни на онзи, който е затворил от чакане",
    "ringBackWhenCallerHangsUpHelp": "Той пак иска таксито, което е поръчал. Изключено е за фирма, която предпочита да не звъни на номер, който не я е молил.",
    "ringBackAttempts": "Опитай обратно позвъняване",
    "ringBackAttemptsHelp": "Колко пъти да се звъни на човек, който не вдига. Нула изключва обратните позвънявания напълно, във всеки режим.",
    "ringBackRetrySeconds": "Изчакай между опитите",
    "ringBackRetrySecondsHelp": "Достатъчно дълго, че второто позвъняване да не е същото позвъняване.",
    "announceArrivalTime": "Казвай след колко минути",
    "announceArrivalTimeHelp": "Изключено, съобщението казва, че колата е на път, без да обещава време. Фирма, чиито коли чакат на един мост, може да предпочете това пред обещанието за пет минути два пъти на ден.",
    "announcementRepeats": "Пусни съобщението",
    "announcementRepeatsHelp": "Два пъти е обичайно: номер на кола, чут веднъж по телефона, е номер, чут наполовина.",
    "holdMusicClass": "Музика на изчакване",
    "holdMusicClassHelp": "Класът музика на изчакване, както централата го нарича. Всяка инсталация има един на име „default“.",
    "promptSet": "Папка със записите",
    "promptSetHelp": "Къде на централата стоят записаните съобщения на тази фирма, под папката ѝ със звуци. Друг глас или друг език е друга папка и нищо повече.",
    "unitChannels": "разговора",
    "unitCallers": "чакащи",
    "unitAttempts": "пъти",
    "unitTimes": "пъти",
    "test": "Тествай връзката",
    "testing": "Тестване…",
    "couldNotTest": "Връзката не можа да бъде тествана.",
    "doorCalls": "Разговори",
    "doorExtensions": "Телефони на диспечерите",
    "reachable": "Работи",
    "result": {
      "NotConfigured": "Не е настроено",
      "Unauthorised": "Грешен потребител или парола",
      "Unreachable": "Няма отговор",
      "Reachable": "Работи"
    },
    "groupRinging": "Звънене и бюра",
    "groupRingingHelp": "Колко дълго звънят телефоните, кога клиент на изчакване звъни отново на диспечера си и как се споделят настолните телефони.",
    "ringSeconds": "Време за звънене",
    "ringSecondsHelp": "Колко дълго звънят телефоните на диспечерите, преди клиентът да чуе извинението и обаждането да стане пропуснато.",
    "holdRecallSeconds": "Време на изчакване, преди да звънне отново",
    "holdRecallSecondsHelp": "Клиент на изчакване звъни на диспечера, който го е задържал, след толкова време и отново след същото, ако никой не вдигне — за да не бъде забравен никой.",
    "deskPhonesBelongTo": "Настолните телефони са на",
    "deskPhonesBelongToHelp": "Бюрото: който влезе на него, има телефона му и казва кое е бюрото при вход. Диспечера: вие давате на всеки неговия телефон по-долу.",
    "belongToDesk": "Бюрото",
    "belongToDispatcher": "Диспечера",
    "callDistribution": "Как обажданията стигат до бюрата",
    "callDistributionHelp": "Всички наведнъж: звънят всички бюра и който вдигне пръв, го взема. Редуване: едно обаждане на едно бюро, следващото на следващото бюро, и така в кръг. Първото свободно бюро: първото бюро от списъка отдолу, когато е свободно, второто — само когато първото е заето, и така нататък. Диспечер в браузъра без бюро идва след всички бюра.",
    "distributionAllAtOnce": "Всички бюра наведнъж",
    "distributionTakeTurns": "Бюрата се редуват",
    "distributionInOrder": "Първото свободно бюро",
    "deskBusyWhen": "Бюрото е заето, когато",
    "deskBusyWhenHelp": "Настолният телефон поема едно обаждане. Ако на бюрото има няколко: заето ли е бюрото само когато всичките му телефони са заети, или щом диспечерът говори на някой от тях? И в двата случая, когато всички бюра са заети, свободните телефони пак звънят.",
    "busyAllPhones": "Всички телефони са заети",
    "busyAnyPhone": "Някой телефон е зает",
    "nextDesk": "Когато бюрото не вдига",
    "nextDeskHelp": "Може да звъни само то до края на времето за звънене, или след малко да звъни и следващото бюро, после и по-следващото. Бюрото, което вече звъни, продължава да звъни.",
    "nextDeskNever": "Звъни само то",
    "nextDeskToo": "Звъни и следващото",
    "nextDeskAfter": "Следващото бюро звъни след",
    "nextDeskAfterHelp": "Колко време бюрото звъни само, преди да се включи следващото. Дръжте го по-кратко от времето за звънене, иначе следващото бюро никога не звъни.",
    "deskPhoneServer": "Адрес, към който се регистрират настолните телефони",
    "deskPhoneServerHelp": "Телефонната система, както я достига офисната мрежа — адресът ѝ, с :порт, ако не е 5060. Показва се до паролата на всеки нов настолен телефон."
  },
  "calls": {
    "ringing": "Звъни",
    "newCaller": "Нов клиент",
    "newCallerHelp": "Няма записан разговор с този номер. Приемете поръчката и адресът се запазва за следващия път.",
    "noName": "Няма записано име",
    "noAddresses": "Още няма запазени адреси.",
    "withheld": "Скрит номер",
    "dialledLine": "На номер {{number}}",
    "blocked": "Този клиент е блокиран.",
    "take": "Поеми разговора",
    "dismiss": "Скрий",
    "known": "Познат клиент",
    "savedAddresses": "Запазени адреси",
    "driversSay": "Шофьори: ★ {{stars}} ({{count}})",
    "noShows_one": "{{count}} неявяване",
    "noShows_other": "{{count}} неявявания"
  },
  "softphone": {
    "title": "Телефон",
    "off": "Няма телефон",
    "connecting": "Свързване…",
    "registered": "Готов · {{extension}}",
    "reconnecting": "Повторно свързване…",
    "failed": "Телефонът не можа да се свърже.",
    "offline": "Няма връзка",
    "devices": "Слушалки",
    "microphone": "Микрофон",
    "speaker": "Говорител",
    "systemDefault": "По подразбиране",
    "incoming": "Обаждане от {{from}}",
    "answer": "Вдигни",
    "reject": "Откажи",
    "calling": "Звъни на {{to}}…",
    "cancel": "Отказ",
    "hangUp": "Затвори",
    "mute": "Заглуши",
    "hold": "Задръж",
    "keypad": "Клавиатура",
    "transfer": "Прехвърли",
    "transferTo": "Прехвърли на",
    "dismiss": "Скрий",
    "lostOnReload": "Страницата беше презаредена по време на разговор и разговорът е прекъснат. Клиентът трябва да бъде потърсен обратно.",
    "waitingForCar": "Чака кола",
    "parked": "Клиентът е на изчакване. Ще му бъде казано коя кола идва веднага щом шофьор приеме поръчката.",
    "parkOnSim": "Тази линия е SIM. Кажете на клиента, че ще му позвъните, и затворете — системата ще го направи, щом се намери кола.",
    "willRingBack": "Кажете на клиента, че ще му позвъните с колата, и затворете.",
    "couldNotPark": "Клиентът не можа да бъде поставен на изчакване.",
    "idle": "Никой не е на линия.",
    "onACall": "В разговор",
    "ringing": "звъни",
    "callingOut": "звъним",
    "answerFailed": "Разговорът не беше вдигнат — проверете микрофона. Клиентът още звъни.",
    "microphoneAccess": {
      "allow": "Разреши микрофона",
      "recheck": "Провери отново",
      "askable": "Този телефон още няма достъп до микрофона. Разрешете го сега, за да не се окаже първият разговор за смяната този, който пита.",
      "refused": "Микрофонът е блокиран за този сайт и разговорите няма да носят гласа ви. Разрешете го от настройките на браузъра — катинарчето до адреса — и проверете отново.",
      "missing": "На този компютър не е открит микрофон. Включете такъв и проверете отново: разговорите ще се свързват, но клиентът няма да чува нищо.",
      "unknown": "Не е ясно дали този телефон може да ползва микрофона. Разрешете го сега, вместо да разберете по време на разговор."
    },
    "onDesk": "{{desk}} · {{extension}}",
    "deskTakenOver": "{{name}} седна на {{desk}}. Телефонът му вече звъни за него.",
    "deskUnreachableFallback": "{{desk}} не е достъпен. Обажданията звънят в този браузър, докато се върне.",
    "deskUnreachable": "{{desk}} не е достъпен и за вас не звъни нищо друго. Проверете кабела му или разрешете браузърът да звъни от менюто.",
    "couldNotHold": "Клиентът не можа да бъде задържан.",
    "ringsOnDesk": "Обажданията звънят на {{desk}} ({{extension}}). Вдигайте от слушалката.",
    "secondCall": "второ обаждане",
    "answerSecond": "Вдигни, задръж първия",
    "heldHere": "Задържан тук: {{peer}}",
    "resume": "Продължи",
    "answerOn": "Вдигам на",
    "answerOnBrowser": "Този браузър",
    "answerOnDesk": "Настолен телефон",
    "ringBrowserWhenDeskUnreachable": "Звъни в браузъра, когато настолният телефон не е достъпен",
    "ringDeskWhenBrowserUnreachable": "Звъни на настолния телефон, когато браузърът е затворен",
    "ringOther": "Звъни на другия телефон"
  },
  "held": {
    "title": "Чакат кола",
    "ofLines": "{{held}} от {{max}} линии задържат",
    "waitingFor": "чака {{time}}"
  },
  "missed": {
    "title": "За връщане на обаждане",
    "waiting": "{{count}} чакащи",
    "show": "Покажи",
    "hide": "Скрий",
    "callBack": "Обади се",
    "clear": "Изчисти",
    "confirmClear": "Изчисти",
    "reason": "Причина",
    "reasonPlaceholder": "Друга причина…",
    "failed": "Не се получи. Може някой друг вече да го е поел.",
    "none": "Няма на кого да се звънне.",
    "agoMinutes_one": "преди {{count}} мин",
    "agoMinutes_other": "преди {{count}} мин",
    "agoHours_one": "преди {{count}} ч",
    "agoHours_other": "преди {{count}} ч",
    "agoDays_one": "преди {{count}} ден",
    "agoDays_other": "преди {{count}} дни",
    "reasons": {
      "served": "Вече обслужен",
      "wrongNumber": "Грешен номер",
      "noAnswer": "Не отговаря",
      "notNeeded": "Вече не иска"
    },
    "otherReason": "Друга причина"
  },
  "duty": {
    "title": "Отработени дни и колко струват",
    "intro": "Приходът на фирмата е брой отработени дни, умножен по ставка. Тези настройки определят какво е един ден; ставката по-долу определя колко струва, а всяка промяна е нова версия, за да не преоценява мартенското повишение февруари.",
    "minimumMinutes": "Минимум за платен ден",
    "minimumMinutesHelp": "Минути на смяна през целия местен ден, преди той да се брои. Сесиите се събират; три пъти по двайсет и пет минути са ден. Нула означава, че всяко излизане на смяна се брои.",
    "weekStartsOn": "Седмицата започва в",
    "weekStartsOnHelp": "Кога се нулира седмичният таван и коя е първата колона на седмичните изгледи.",
    "silenceTimeout": "Затвори мълчаща смяна след",
    "silenceTimeoutHelp": "Минути, в които смяната може да не подава позиция, преди системата да я закрие. Паркирана кола пак подава на всеки четиридесет и пет секунди, така че мълчание значи затворено приложение или изтощена батерия. По-кратко — и шофьор в подземен паркинг бива изписан, докато работи.",
    "maxShiftHours": "Не повече от",
    "maxShiftHoursHelp": "Часа. Таванът на една смяна, прилаган и от системата, и от справката, за да струва забравено изписване един сгрешен ден, а не едно сгрешено тримесечие.",
    "driversSeeTheirDues": "Шофьорите виждат своите задължения в приложението",
    "driversSeeTheirDuesHelp": "Шофьор, който е следил сумата цял месец, не се изненадва накрая. Изключването отказва самата заявка, не само екрана. Никога чужди суми, така или иначе.",
    "driversSeeTheirTakings": "Шофьорите виждат и оборота на колата си",
    "driversSeeTheirTakingsHelp": "Курсове, километри и суми в брой, с карта и по сметка, до задълженията им — същите числа като в книгата на смените. Изключено по подразбиране, защото важи сумата в офиса. Изисква задълженията да са включени.",
    "days": {
      "Sunday": "неделя",
      "Monday": "понеделник",
      "Tuesday": "вторник",
      "Wednesday": "сряда",
      "Thursday": "четвъртък",
      "Friday": "петък",
      "Saturday": "събота"
    },
    "introduce": "Нова ставка",
    "introduceHelp": "Това добавя версия, а не променя текущата. Вече отработените дни запазват ставката, която е била в сила тогава — затова приключен месец остава обясним и след година.",
    "introduceAction": "Въведи в сила",
    "appliesTo": "За кого",
    "appliesToHelp": "За всички или за един шофьор с друга уговорка.",
    "everybody": "За всички",
    "dailyAmount": "Дневна ставка",
    "dailyAmountHelp": "Колко струва един платен ден, в {{currency}}.",
    "weeklyCap": "Седмичен таван",
    "weeklyCapHelp": "Най-много, до което може да стигне една седмица, в {{currency}}. Празно — без таван.",
    "noCap": "без таван",
    "effectiveFrom": "В сила от",
    "fromTheStart": "От самото начало",
    "effectiveFromHelp": "Полунощ на тази дата, по часовата зона на фирмата.",
    "effectiveTo": "До",
    "inForce": "в сила",
    "endDeal": "Прекрати уговорката",
    "history": "Всички ставки на фирмата",
    "historyHelp": "Пазят се, за да остане приключеният месец обясним. Нищо тук не се редактира; промяната е нов ред.",
    "unitHours": "часа",
    "none": "Още няма зададена ставка.",
    "cancel": "Отказ"
  },
  "reports": {
    "sections": "Справки",
    "loading": "Изчислява се…",
    "export": "Свали CSV",
    "total": "Общо от {{count}} показани",
    "tab": {
      "shiftBook": "Шофьорска книга",
      "demand": "Кога и къде",
      "service": "Обслужване"
    },
    "period": {
      "label": "Период",
      "thisWeek": "Тази седмица",
      "lastWeek": "Миналата седмица",
      "thisMonth": "Този месец",
      "lastMonth": "Миналия месец",
      "lastThreeMonths": "Последните три месеца",
      "custom": "Друг период",
      "from": "От",
      "to": "До",
      "showing": "{{from}} – {{to}} · {{zone}}"
    },
    "sources": {
      "Phone": "Телефон",
      "RiderApp": "Приложение",
      "Web": "Уеб",
      "Api": "Интеграция",
      "Street": "От улицата"
    },
    "shiftBook": {
      "views": "Изгледи на шофьорската книга",
      "view": {
        "fleet": "Всички шофьори",
        "grid": "Таблица по дни"
      },
      "driver": "Шофьор",
      "filter": "Търси шофьор",
      "filterHint": "име или кратък номер",
      "daysWorked": "Отработени дни",
      "daysCharged": "Платени дни",
      "hours": "Часове",
      "hoursOnDuty": "Часове на смяна",
      "hoursOnBreak": "Часове в почивка",
      "break": "Почивка",
      "sessions": "Сесии",
      "day": "Ден",
      "chargeable": "Брои се",
      "cost": "Дължимо ({{currency}})",
      "charged": "Начислено ({{currency}})",
      "outstanding": "Остатък ({{currency}})",
      "outstandingAllTime": "Остатък, за цялото време",
      "amountOwed": "Дължимо за периода",
      "rides": "Курсове",
      "takings": "Оборот ({{currency}})",
      "cashCard": "в брой {{cash}} · с карта {{card}}",
      "settled": "Разплатено",
      "markPaid": "Отбележи като платено",
      "yes": "Да",
      "left": "напуснал",
      "belowMinimum": "под минимума",
      "unratedDays": "{{count}} без ставка",
      "unratedDaysHint": "Дни, които се броят, но за които не е имало ставка. Показани, а не начислени като нула.",
      "unpriced": "{{count}} без сума",
      "unpricedHint": "Приключени курсове без записана сума. Преброени, а не приети за нула.",
      "noRate": "Тази фирма още не е определила колко струва един ден, затова паричните колони са празни. Дните и часовете се броят.",
      "openSettings": "Задай ставка",
      "mixedCurrency": "Периодът обхваща смяна на валутата, така че сборът събира две валути.",
      "backToFleet": "Обратно към всички шофьори",
      "weeks": "По седмици",
      "weekStarting": "Седмица от",
      "uncapped": "Преди тавана ({{currency}})",
      "cap": "Таван",
      "capApplied": "достигнат таван",
      "partialWeek": "периодът отрязва тази седмица",
      "ending": {
        "SweptOff": "системата закри тази смяна",
        "Capped": "няма изписване — ограничена",
        "Running": "още тече",
        "EndedByOffice": "офисът прекрати тази смяна"
      },
      "payments": "Плащания",
      "showPayments": "Покажи плащанията",
      "noPayments": "Още няма записани.",
      "paidAt": "Платено на",
      "amount": "Сума",
      "note": "Бележка",
      "reverse": "Сторнирай",
      "reverseReason": "Защо това плащане е сгрешено?",
      "attribution": "Курсът се брои за деня, в който е приключил; работният ден — за деня, в който е започнала смяната. Нощната смяна затова попада на две различни места: парите следват таксиметъра, денят следва човека.",
      "outstandingIsAllTime": "Начисленото и оборотът следват показания период. Остатъкът е за цялото време.",
      "paidInPeriod": "Платено ({{currency}})",
      "paidInPeriodShort": "Платено за периода",
      "daysChargedSub_one": "{{shown}} платен",
      "daysChargedSub_other": "{{shown}} платени",
      "driverCount_one": "{{shown}} шофьор",
      "driverCount_other": "{{shown}} шофьори",
      "driversOwe_one": "{{shown}} шофьор дължи",
      "driversOwe_other": "{{shown}} шофьори дължат",
      "paidSub": "{{amount}} платени за периода",
      "breakSub": "{{hours}} в почивка",
      "outstandingAllTimeIn": "Остатък, за цялото време ({{currency}})",
      "filterPlaceholder": "Търси шофьор — име или кратък номер",
      "byDay": "По дни",
      "nobodyWorked": "Никой не е бил на смяна през този период.",
      "noMatch": "Няма шофьор, който да отговаря на търсенето.",
      "paymentsHidden": "Не се изтеглят, докато не ги поискате.",
      "reverseTitle": "Сторниране на плащането",
      "reverseConfirm": "Сторнирай",
      "cancel": "Откажи",
      "notOnDuty": "Не е бил на смяна през този период."
    },
    "grid": {
      "worked": "{{day}}: {{hours}} на смяна",
      "notWorked": "{{day}}: не е работил",
      "legend": "По-тъмното е по-дълго. Бледа клетка с контур е ден под минимума от {{minutes}} минути — брои се за работен и не струва нищо. Празна клетка значи, че не е работено.",
      "cell": "{{driver}}, {{day}}: {{hours}} на смяна"
    },
    "demand": {
      "orders": "Поръчки",
      "completed": "Изпълнени",
      "unfilled": "Без намерена кола",
      "busiest": "Най-натоварен час: {{day}} в {{hour}}.",
      "byHour": "По час от денонощието",
      "cell": "{{day}} {{hour}}: {{orders}} поръчки, {{unfilled}} без кола",
      "unfilledLegend": "Клетка с контур съдържа поне една поръчка, за която не е намерена кола.",
      "byZone": "По зони",
      "zone": "Зона",
      "outsideEveryZone": "Извън всички зони",
      "cancellations": "Отказани",
      "cancelledBy": "Отказана от",
      "afterAssignment": "Кола вече е тръгнала",
      "afterACarWasSent": "да",
      "beforeACarWasSent": "не",
      "sources": "Откъде идва работата",
      "source": "Източник"
    },
    "service": {
      "orders": "Поръчки",
      "medianToAssign": "Медиана до намиране на кола",
      "worstToAssign": "Най-дълго до намиране на кола",
      "medianToArrive": "Медиана до пристигане",
      "worstToArrive": "Най-дълго до пристигане",
      "noCarRate": "Без намерена кола",
      "byHour": "Изчакване по час от денонощието",
      "byHourAlt": "Медиана до намиране на кола и до пристигане, за всеки час от денонощието",
      "assignAt": "{{hour}}:00 — {{wait}} до намиране на кола, {{orders}} поръчки",
      "arriveAt": "{{hour}}:00 — {{wait}} до пристигане, {{orders}} поръчки",
      "drivers": "Кой отговаря",
      "offered": "Предложени",
      "accepted": "Приети",
      "declined": "Отказани",
      "timedOut": "Без отговор",
      "acceptanceRate": "Приемане",
      "completed": "Курсове",
      "acceptanceIsDispatchs": "Това е същият процент на приемане, с който разпределението тежи предложенията, а не втори. Предложения, спечелени от друг шофьор, и такива, изтеглени от диспечер, не се броят срещу никого.",
      "ratings": "Какво казаха пътниците",
      "noRatings": "Никой не е оценил курс в този период.",
      "averageOf": "Средно {{average}} от {{count}} пътници.",
      "noDrivers": "В този период не са изпращани предложения.",
      "noCancellations": "В този период няма отказани поръчки.",
      "journeys": "Пътувания",
      "journeysHelp": "Поръчките на този шофьор за същия период, всяка готова за възпроизвеждане"
    },
    "clients": {
      "clients": "Клиенти",
      "ofOrders": "от {{shown}} поръчки",
      "newClients": "Нови клиенти",
      "returning": "Повтарящи се",
      "topTenShare": "Дял на първите десет от курсовете",
      "topTenSpendSub": "{{share}} от платеното",
      "show": "Първите",
      "all": "Всички",
      "byRides": "Най-много курсове",
      "bySpend": "Най-много платили",
      "costly": "Скъпи клиенти",
      "costlyHint": "Отказали при вече тръгнала кола, или не се явили при пристигането ѝ.",
      "costlyDetail": "{{after}} след изпратена кола · {{noShows}} неявявания · {{cancelled}} отказани общо",
      "failed": "Клиенти, които подведохме",
      "failedHint": "Техни поръчки, за които не се намери кола.",
      "failedDetail": "{{orders}} поръчки, {{rides}} курса",
      "noClients": "Никой не е поръчвал през този период.",
      "noCostly": "Никой не е отказал тръгнала кола и никой не е отсъствал.",
      "noFailed": "За всяка поръчка през този период се намери кола.",
      "lost": "Затихнали",
      "lostHint": "Пътували между {{from}} и {{to}} и оттогава не са поръчвали.",
      "noLost": "Всеки, който е пътувал през предишния период, е поръчал отново.",
      "client": "Клиент",
      "ridesThen": "Курсове тогава",
      "spentThen": "Платено тогава",
      "lastRide": "Последен курс",
      "loyalty": "Колко често пътуват",
      "ridesInPeriod": "Курсове през периода",
      "bandOpen": "{{min}} или повече",
      "bandNone": "Нито един завършен",
      "bandOne": "Един",
      "bandRange": "{{min}} до {{max}}",
      "everyone": "Всички клиенти",
      "filter": "Намери клиент",
      "filterHint": "име или номер",
      "orders": "Поръчки",
      "rides": "Курсове",
      "cancelled": "Отказани",
      "unfilled": "Без кола",
      "spent": "Платено",
      "averageFare": "Средна сметка",
      "payment": "В брой / карта / сметка",
      "source": "Телефон / приложение",
      "since": "Клиент от",
      "new": "Нов",
      "paymentSplit": "{{cash}} / {{card}} / {{account}}",
      "unrecorded": "{{amount}} неотбелязано",
      "sourceSplit": "{{phone}} / {{app}}",
      "attribution": "Всяка цифра следва деня, в който поръчката е направена, както в „Кога и къде“. Дневникът на смените следва деня, в който курсът е завършил, затова курс през полунощ на ръба на периода може да попадне в различни месеци на двете справки.",
      "anonymous": "{{shown}} поръчки са приети без номер и не принадлежат на никого тук.",
      "unknown": "Без име и номер",
      "barAlt": "{{value}}",
      "summaryRides": "Тези {{shown}} са направили {{share}} от курсовете през периода.",
      "summarySpend": "Тези {{shown}} са платили {{share}} от всичко взето.",
      "summaryCostly": "Тези {{shown}} са {{share}} от {{total}} изгубени курса.",
      "summaryFailed": "Тези {{shown}} са {{share}} от {{total}} поръчки без кола.",
      "loyaltyViews": "Изглед на лоялността",
      "viewPie": "Диаграма",
      "viewTable": "Таблица",
      "share": "Дял",
      "slice": "{{band}}: {{count}} клиенти, {{share}}",
      "pieAlt": "Колко клиенти колко често са пътували през периода, като пръстен",
      "journeys": "Пътуванията му",
      "journeysOf": "Пътувания на {{name}}"
    },
    "directory": {
      "search": "Номер, име или адрес",
      "origin": "Кои клиенти",
      "everybody": "Всички",
      "imported": "Внесени",
      "here": "От тук",
      "order": "Подредба",
      "recent": "Последни",
      "mostUsed": "Най-използвани",
      "clients": "Клиенти",
      "none": "Няма такъв клиент.",
      "client": "Клиент",
      "addresses": "Адреси",
      "uses": "Ползвания",
      "lastUsed": "Последно",
      "importedOne": "Внесен",
      "app": "Приложение",
      "blocked": "Блокиран",
      "choose": "Изберете клиент, за да видите кой е и къде ходи.",
      "name": "Име",
      "otherNumbers": "Други номера",
      "notes": "Бележки за диспечера",
      "knownSince": "Познат от",
      "importedOn": "внесен на {{date}}",
      "rides": "Поръчки тук",
      "noOrders": "Още няма поръчки тук",
      "orderCounts": "{{total}} — {{completed}} завършени, {{cancelled}} отказани",
      "lastRide": "Последен курс",
      "yes": "Влиза в приложението",
      "no": "Не влиза в приложението",
      "knownAddresses": "Известни адреси",
      "noAddresses": "За този клиент още не е известен адрес.",
      "address": "Адрес",
      "locked": "Заключен",
      "noPoint": "Без точка",
      "recentOrders": "Последни поръчки",
      "when": "Кога",
      "route": "Откъде / докъде",
      "state": "Състояние",
      "fare": "Цена",
      "typedAs": "Записан като {{address}}"
    },
    "title": "Справки",
    "about": {
      "shiftBook": "Какво е работил всеки шофьор, колко струва това и колко още се дължи.",
      "demand": "Кога идва работата, откъде идва и за какво не е намерена кола.",
      "service": "Колко чака обаждащият се, кой отговаря на предложенията и какво казаха пътниците.",
      "clients": "Кой пътува най-много, кой плаща най-много, кой струва курсове и кой е затихнал.",
      "directory": "Всеки клиент, когото фирмата ви познава — и тези, които предишната ви система ви е предала, — с адресите, до които всеки от тях ходи. Намерете всекиго по номер, име или адрес.",
      "calls": "Всеки разговор, намерен по номер или поръчка, и записът му — да се чуе, свали или изтрие.",
      "journeys": "Всяка поръчка, приключила в периода, и какво се е объркало в нея — а всяка от тях може да се пусне отново на картата, минута по минута.",
      "addresses": "Адресите, поръчвани най-често за периода — откъдето клиентите тръгват и докъдето отиват, когато поръчват от приложението, — които още не са от адресите на фирмата. Заключете ги и следващата кола ще спре пред верния вход. Първо тези от Google: всяко име от Google при поставяне на точката се плаща."
    },
    "calls": {
      "search": "Номер или поръчка",
      "withheld": "Скрит номер",
      "order": "Поръчка {{reference}}",
      "dismiss": "Затвори",
      "direction": {
        "label": "Посока",
        "all": "И двете",
        "Inbound": "Входящи",
        "Outbound": "Изходящи"
      },
      "outcome": {
        "label": "Резултат",
        "all": "Всички",
        "answered": "Отговорени",
        "unanswered": "Пропуснати",
        "other": "Отказани или неуспешни"
      },
      "outcomes": {
        "InProgress": "В момента",
        "Answered": "Отговорено",
        "Abandoned": "Затворено",
        "Missed": "Пропуснато",
        "Failed": "Неуспешно",
        "Refused": "Отказано"
      },
      "dispatcher": "Диспечер",
      "everyDispatcher": "Всички диспечери",
      "recordedOnly": "Със запис",
      "clear": "Изчисти филтрите",
      "none": "Няма разговори за този период.",
      "noneMatch": "Нито един разговор от периода не отговаря.",
      "toCallBack": "Още не е върнат",
      "listenTo": "Пусни разговора с {{who}}",
      "notHeard": "Още не е слушан",
      "heard_one": "Слушан веднъж",
      "heard_other": "Слушан {{count}} пъти",
      "showing": "{{from}}–{{to}} от {{total}}",
      "newer": "По-нови",
      "older": "По-стари",
      "footnote": "Всички разговори за периода, най-новите отгоре. Всеки запис се пази до датата си и после се изтрива; пускането, свалянето и изтриването му се записват с това кой го е направил, и този запис остава и след като самият запис го няма.",
      "tiles": {
        "calls": "Разговори",
        "split": "{{inbound}} входящи · {{outbound}} изходящи",
        "answered": "Отговорени",
        "answeredOf": "{{answered}} от {{inbound}} входящи",
        "unanswered": "Пропуснати",
        "toCallBack_one": "{{count}} още не е върнат",
        "toCallBack_other": "{{count}} още не са върнати",
        "allCalledBack": "Всички са обработени",
        "ring": "Звънене до отговор",
        "ringSub": "Средно, входящи разговори",
        "recorded": "Записани",
        "recordedSub": "{{time}} разговор",
        "recordedHours": "{{hours}} ч разговор"
      },
      "columns": {
        "when": "Кога",
        "who": "Обаждащ се",
        "dispatcher": "Диспечер",
        "outcome": "Резултат",
        "ring": "Звънене",
        "talk": "Разговор",
        "order": "Поръчка",
        "recording": "Запис"
      },
      "trail": {
        "Played": "Слушан",
        "Downloaded": "Свален",
        "Deleted": "Изтрит",
        "Expired": "Изтекъл",
        "retention": "Срок на съхранение"
      },
      "player": {
        "label": "Плейър за записи",
        "play": "Пусни",
        "pause": "Пауза",
        "previous": "Предишен запис",
        "next": "Следващ запис",
        "back10": "10 секунди назад",
        "forward10": "10 секунди напред",
        "position": "Позиция в записа",
        "speed": "Скорост",
        "download": "Свали",
        "delete": "Изтрий",
        "deleteCustomer": "Изтрий всички на този клиент",
        "close": "Затвори плейъра",
        "takenBy": "с {{name}}",
        "gone": "Записът е изтрит",
        "deletesIn_one": "Изтрива се утре",
        "deletesIn_other": "Изтрива се след {{count}} дни",
        "neverPlayed": "Никой не го е слушал",
        "playedBy_one": "Слушан веднъж — от {{name}}, {{at}}",
        "playedBy_other": "Слушан {{count}} пъти — последно от {{name}}, {{at}}",
        "someone": "Човек, който вече не е във фирмата",
        "keys": "Интервал пуска · ← → 10 с · Shift ← → запис",
        "noTrail": "Никой не го е пускал, свалял или изтривал.",
        "couldNotPlay": "Записът не се пусна. Опитайте отново след малко.",
        "couldNotSave": "Записът не можа да се свали.",
        "couldNotDelete": "Записът не можа да се изтрие.",
        "deletedOne": "Записът е изтрит. Разговорът остава в дневника.",
        "deletedCustomer_one": "Изтрит е {{count}} запис на този клиент.",
        "deletedCustomer_other": "Изтрити са {{count}} записа на този клиент.",
        "deleteTitle": "Да се изтрие ли този запис?",
        "deleteBody": "Записът на разговора с {{who}} от {{at}} се изтрива завинаги. Самият разговор остава в дневника, а изтриването се записва с вашето име.",
        "deleteCustomerTitle": "Да се изтрият ли всички записи на този клиент?",
        "deleteCustomerConfirm": "Изтрий всички",
        "deleteCustomerBody": "Всички записи на {{who}}, които фирмата пази, се изтриват завинаги — това, което човек иска, когато упражнява правото си да бъде забравен. Разговорите му остават в дневника.",
        "keep": "Запази"
      },
      "replayOrder": "Възпроизведете пътуването, в което се превърна това обаждане"
    },
    "journeys": {
      "search": "Номер на поръчка, телефон, име, адрес или регистрационен номер",
      "state": {
        "label": "Как е приключила",
        "all": "Всички"
      },
      "sourceLabel": "Приета по",
      "source": {
        "all": "Всички",
        "phone": "Телефон",
        "app": "Приложение",
        "street": "Улица"
      },
      "driver": "Шофьор",
      "everyDriver": "Всички шофьори",
      "vehicle": "Кола",
      "everyVehicle": "Всички коли",
      "oneClient": "Само един клиент",
      "oneClientClear": "Покажи отново всички клиенти",
      "clear": "Изчисти",
      "onlyProblems": "Само курсове с:",
      "whatCounts": "Какво е проблем",
      "problems": {
        "late": "Закъснение",
        "detour": "Обиколен път",
        "longWait": "Дълго чакане",
        "longStop": "Спиране по пътя",
        "speeding": "Превишена скорост",
        "cancelledOnTheWay": "Отказан по пътя",
        "signalLost": "Загубен сигнал",
        "noTrack": "Няма запис"
      },
      "tiles": {
        "orders": "Поръчки",
        "ordersSub": "приключили в периода",
        "late": "над {{minutes}} мин след очакваното",
        "detour": "с {{percent}}% или повече над най-краткия път",
        "longWait": "{{minutes}} мин или повече на адреса",
        "speeding": "над {{town}} км/ч в града, {{road}} извън"
      },
      "columns": {
        "when": "Поискана",
        "order": "Поръчка",
        "client": "Клиент",
        "driver": "Шофьор",
        "state": "Край",
        "arrival": "Пристигане",
        "wait": "Чакал",
        "distance": "Разстояние",
        "fare": "Цена",
        "problems": "Проблеми"
      },
      "replay": "Възпроизведи",
      "replayHelp": "Вижте я на картата",
      "anonymous": "Без име",
      "bookedFor": "за {{time}}",
      "versusBest": "{{percent}}% спрямо най-краткия",
      "none": "Няма поръчки, приключили в този период.",
      "noneMatch": "Няма поръчки, които отговарят на филтрите.",
      "showing": "{{from}}–{{to}} от {{total}}",
      "newer": "По-нови",
      "older": "По-стари",
      "footnote": "Поръчките се броят по деня, в който са поискани. Очакваното пристигане е времето по маршрута от мястото, където шофьорът е поел поръчката, или часът на предварителната поръчка. Пътуванията се пазят от деня, в който се появи тази справка; по-стар курс показва маршрута, по който е изчислена цената, без часове.",
      "noDriver": "Никой шофьор не я пое",
      "someDriver": "шофьор",
      "automatic": "автоматично",
      "chapter": {
        "before": "Преди всичко",
        "call": "Обаждането",
        "searching": "Търсене на кола",
        "approach": "Към клиента",
        "waiting": "Чакане",
        "aboard": "Клиентът е в колата"
      },
      "phase": {
        "approach": "Към клиента",
        "waiting": "Чакане на адреса",
        "aboard": "Клиентът е в колата"
      },
      "span": {
        "stop": "Стои на място {{time}}",
        "silence": "Без сигнал {{time}}",
        "speeding": "Превишена скорост, до {{speed}} км/ч при ограничение {{limit}}"
      },
      "events": {
        "title": "Какво се случи",
        "created": "Поръчката е приета · {{who}}",
        "streetRide": "{{driver}} я взе от улицата",
        "offered": "Предложена на {{driver}}",
        "accepted": "{{driver}} я пое",
        "declined": "{{driver}} отказа",
        "timedOut": "{{driver}} не отговори",
        "reassigned": "Взета от {{driver}}",
        "superseded": "{{driver}} закъсня — друг я пое",
        "withdrawn": "Предложението към {{driver}} е оттеглено",
        "takenByHand": "Поета ръчно · {{who}}",
        "automaticResumed": "Върната на автоматичното разпределяне",
        "needsHuman": "Автоматичното разпределяне поиска диспечер",
        "atRisk": "Предварителната поръчка е застрашена: още няма кола",
        "noted": "Отбелязано",
        "setOff": "Шофьорът тръгна",
        "arrived": "Шофьорът е на адреса",
        "pickedUp": "Клиентът се качи",
        "completed": "Курсът приключи",
        "noShow": "Клиентът не дойде",
        "cancelled": "Отказана · {{who}}",
        "rated": "Оценка {{stars}} ★",
        "stopReached": "Стигна спирката · {{address}}",
        "destinationReached": "Стигна крайната точка · {{address}}",
        "callIn": "Входящо обаждане",
        "callOut": "Изходящо обаждане"
      },
      "measures": {
        "title": "Очаквано и реално",
        "none": "Няма какво да се сравни: не е изпратена кола.",
        "accepted": "Шофьорът я пое",
        "expected": "Очакван на адреса",
        "basis": {
          "booked": "часът на предварителната поръчка",
          "routed": "времето по маршрута от мястото, където шофьорът я пое"
        },
        "arrived": "Пристигна",
        "neverArrived": "Не пристигна",
        "late": "{{time}} закъснение",
        "early": "{{time}} по-рано",
        "stood": "Спря",
        "fromPin": "на {{distance}} от точката",
        "waited": "Чака",
        "approach": "Към клиента",
        "ride": "Курсът",
        "recommended": "най-краткият път е {{distance}}",
        "rideTime": "Време на курса",
        "routerSays": "по маршрута {{time}}",
        "ended": "Приключи",
        "fromDestination": "на {{distance}} от поисканата крайна точка",
        "fare": "Цена",
        "fareLines": "От какво се състои"
      },
      "fare": {
        "title": "Цената",
        "none": "Няма цена: курсът не се е състоял и нищо не е таксувано.",
        "source": {
          "metered": "по таксиметъра",
          "computed": "по тарифата",
          "fee": "такса за курс, който не се е състоял"
        },
        "quoted": "Обявена",
        "asQuoted": "точно колкото е обявена",
        "overQuote": "с {{amount}} над обявената",
        "underQuote": "с {{amount}} под обявената",
        "computed": "По тарифата",
        "meterAgrees": "колкото таксиметъра",
        "meterOver": "таксиметърът показва с {{amount}} повече",
        "meterUnder": "таксиметърът показва с {{amount}} по-малко",
        "perKm": "На километър",
        "perKmValue": "{{amount}}/км",
        "perKmSub": "за {{distance}} с клиента в колата",
        "detour": "Обиколката",
        "detourCost": "≈ {{amount}}",
        "detourSub": "{{distance}} над най-краткия път",
        "detourNone": "няма",
        "detourNoneSub": "по най-краткия път или близо до него",
        "lines": "От какво се състои",
        "total": "Общо"
      },
      "calls": {
        "title": "Обаждания",
        "jump": "Отиди на обаждането във времевата линия",
        "announced_one": "Казано: {{count}} мин",
        "announced_other": "Казано: {{count}} мин",
        "hear": "Чуй го · {{time}}",
        "notRecorded": "Не е записано"
      },
      "player": {
        "back": "Всички пътувания",
        "timeline": "Времева линия",
        "folded": "{{time}} са сгънати — нищо не се е случило",
        "callTick": "Обаждане в {{time}}",
        "gpx": "GPX",
        "gpxHelp": "Пътят като файл, който отваря всяка програма за карти",
        "print": "Печат",
        "recordedBefore": "Тази поръчка е приключила, преди пътуванията да се пазят. Линията е маршрутът, по който е изчислена цената, без часове, затова не може да се възпроизведе.",
        "noTrack": "Кола е тръгнала, но телефонът ѝ не е изпратил нищо за тази поръчка.",
        "neverTaken": "Никой не пое тази поръчка, затова няма пътуване — само това, което се случи, докато се търсеше кола.",
        "speed": "{{speed}} км/ч",
        "noSignal": "Няма сигнал",
        "hearing": "Обаждането звучи",
        "callMuted": "Обаждане — без звук над 2×",
        "previous": "Предишна глава",
        "back10": "Назад 10 секунди",
        "play": "Пусни",
        "pause": "Пауза",
        "forward10": "Напред 10 секунди",
        "next": "Следваща глава",
        "speedLabel": "Скорост",
        "follow": "Следвай",
        "followHelp": "Дръж колата в средата на картата, докато се възпроизвежда",
        "keys": "Интервал пуска · ← → 10 с · Shift ← → глава · − + скорост · F следвай",
        "beingWritten": "Този курс приключи току-що и пътуването му още се записва. След минута може да се възпроизведе.",
        "askAgain": "Опитай отново"
      },
      "map": {
        "label": "Карта на пътуването",
        "pickup": "Адрес на качване: {{address}}",
        "stop": "Спирка: {{address}}",
        "destination": "Крайна точка: {{address}}",
        "recommended": "Най-кратък път",
        "fareRoute": "Маршрут на цената",
        "silence": "Няма сигнал",
        "unplannedStop": "Спиране по пътя",
        "droppedOff": "Където курсът приключи — не е поискана крайна точка"
      },
      "sheet": {
        "title": "Лист за курса — поръчка {{reference}}",
        "order": "Поръчка",
        "state": "Приключи като",
        "requested": "Поискана",
        "client": "Клиент",
        "from": "От",
        "to": "До",
        "driver": "Шофьор и кола",
        "recommended": "Най-кратък път",
        "problems": "Отбелязано:",
        "printed": "Отпечатано {{when}}"
      },
      "metres": "{{count}} м",
      "speed": {
        "title": "Скорост",
        "limit": "ограничение {{speed}} км/ч",
        "limitTown": "ограничение {{speed}} км/ч в града",
        "limitRoad": "ограничение {{speed}} км/ч извън града",
        "limits": "ограничение {{town}} в града · {{road}} извън, км/ч",
        "none": "За този курс няма записана скорост.",
        "top": "Най-висока",
        "at": "в {{time}}",
        "average": "Средна в движение",
        "averageSub": "без спиранията и светофарите",
        "over": "Над ограничението",
        "never": "нито веднъж",
        "still": "На място",
        "stillSub": "с чакането на адреса",
        "unit": "км/ч",
        "chart": "Скоростта по време на курса, с ограничение {{speed}} км/ч"
      },
      "order": {
        "title": "Поръчката",
        "problems": "Какво не е наред",
        "clean": "Нищо — курсът е спазил правилата на фирмата.",
        "show": "Покажи",
        "showHelp": "Пусни възпроизвеждането от този момент",
        "explain": {
          "late": "Пристигна {{time}} след очакваното време.",
          "detour": "Изминати {{driven}} при {{best}} по най-краткия път — с {{percent}}% повече.",
          "longWait": "Чака {{time}} на адреса.",
          "longStop": "Стоя на място {{time}} в {{at}}, далеч от място, поискано в поръчката.",
          "speeding": "До {{speed}} км/ч при ограничение {{limit}}, в {{at}}.",
          "signalLost": "Без сигнал {{time}} от {{at}}.",
          "cancelledOnTheWay": "Отказана в {{at}}, докато колата е била на път.",
          "cancelledAway": "Отказана в {{at}}, когато колата е била на {{distance}} от адреса.",
          "noTrack": "Кола е тръгнала, но телефонът ѝ не е изпратил нищо за тази поръчка."
        },
        "time": "Времето по части",
        "total": "Общо",
        "asked": "Какво е поискано",
        "taken": "Приета",
        "forWhen": "За кога",
        "now": "веднага",
        "from": "От",
        "notes": "За шофьора",
        "via": "През",
        "to": "До",
        "noDestination": "не е посочена",
        "passengers": "Пътници",
        "car": "Кола",
        "anyCar": "всяка"
      }
    },
    "addresses": {
      "address": "Адрес",
      "bookings": "Поръчки",
      "namedEntrance": "С посочен вход",
      "last": "Последна поръчка",
      "place": "Заключи",
      "empty": "Всички адреси, поръчани за периода, вече са от адресите на фирмата.",
      "namedBy": "Име от",
      "all": "Всички",
      "google": "Google",
      "ours": "Нашите карти",
      "imported": "Внесени",
      "importedAbout": "Адресите, които предишната ви система е имала на картата си, най-поръчваните там първи. Тук не са поръчвани, затова периодът не важи за тях. Заключете един и следващият излиза в списъка.",
      "importedEmpty": "Не е останал внесен адрес с точка за заключване.",
      "ordersBefore": "Поръчки преди",
      "importedOne": "Внесен",
      "order": "Подредба",
      "byBookings": "Най-много поръчки",
      "byLatest": "Най-скоро",
      "byAddress": "По азбучен ред",
      "byCallers": "Най-много клиенти",
      "lastUsed": "Последно ползван",
      "search": "Търси адрес",
      "callers": "Клиенти",
      "spellings": "Написван и: {{list}}",
      "noneFound": "Няма адрес в списъка, който да отговаря на търсенето.",
      "join": "Присъедини…",
      "joinTitle": "Присъедини „{{line}}“ към заключен адрес",
      "joinAbout": "Поръчките и адресите остават написани както са; ще се показват като избрания адрес. Може да се отмени от историята на адреса.",
      "joinSearch": "Търси заключен адрес",
      "joinCandidates": "Към кой заключен адрес",
      "joinNoCandidates": "Няма подобен заключен адрес — потърсете го по име или адрес.",
      "joinMembers": "Какво се присъединява",
      "inPeriod": "В периода",
      "outsidePeriod": "Извън периода",
      "callersAddresses": "Адреси на клиентите",
      "outsideMore": "Показани са най-новите {{shown}} от {{total}}.",
      "reason": {
        "joinedBefore": "Присъединяван преди",
        "same": "Същият адрес",
        "building": "Друг вход",
        "words": "Подобни думи",
        "name": "Име",
        "near": "Наблизо",
        "search": "Търсене",
        "sameName": "Същото име"
      },
      "metres": "{{n}} м",
      "sharesPoint": "на същата точка с още {{n}}",
      "live": "още в движение",
      "far": "на {{n}} м",
      "linked": "вече заключен",
      "joinChosen": "Избрани: {{count}} от {{total}}",
      "joinTarget": "към „{{line}}“",
      "joinConfirm": "Присъедини",
      "joined": "Присъединени към „{{line}}“: {{orders}}, {{destinations}}, {{addresses}}",
      "joinSkipped": "Оставени — {{list}}",
      "skipped": {
        "live": "в движение: {{shown}}",
        "linked": "вече заключени: {{shown}}",
        "far": "далеч: {{shown}}",
        "gone": "вече ги няма: {{shown}}"
      },
      "undo": "Отмени",
      "undone": "Присъединяването е отменено.",
      "dismiss": "Премахни от списъка",
      "dismissTitle": "Да махна ли „{{line}}“ от списъка?",
      "dismissBody_one": "{{shown}} поръчка остава в историята непроменена. Нова поръчка на този адрес го връща.",
      "dismissBody_other": "{{shown}} поръчки остават в историята непроменени. Нова поръчка на този адрес го връща.",
      "dismissConfirm": "Премахни",
      "dismissed": "Премахнато: „{{line}}“.",
      "restore": "Върни",
      "restored": "Върнато в списъка: „{{line}}“.",
      "remove": "Изтрий…",
      "removeTitle": "Да изтрия ли внесените адреси на „{{line}}“?",
      "removeBody": "От подсказките и картотеката изчезват: {{addresses}} на {{callers}}. Поръчките остават. Не може да се отмени; повторен внос на същия файл няма да ги върне.",
      "removeUnderstand": "Разбирам",
      "removeConfirm": "Изтрий",
      "removeNone": "Нищо за изтриване: всеки от тези адреси е ползван оттук.",
      "usedHere": "ползван оттук — остава",
      "removed": "Изтрити: {{addresses}} на {{callers}}.",
      "removedKept": "Запазени: {{kept}} — ползвани оттук или вече заключени.",
      "points": "Точка",
      "withPoint": "С точка",
      "noPoint": "Без точка",
      "noPointAbout": "Адресите, които предишната ви система е внесла без точка. Няма къде да се отвори картата, затова всеки се присъединява към заключен адрес или се изтрива.",
      "noPointEmpty": "Не е останал внесен адрес без точка.",
      "hint": "≈ {{line}} · {{metres}}",
      "hintNear": "≈ {{line}}",
      "hintTitle": "Присъедини към „{{line}}“ — {{reason}}",
      "tiles": {
        "waiting": "Чакат",
        "waitingSub": "поръчани за периода",
        "google": "От Google",
        "googleSub_one": "{{shown}} поръчка с платена справка",
        "googleSub_other": "{{shown}} поръчки с платена справка",
        "imported": "Внесени",
        "importedSub": "с точка от предишната система",
        "noPoint": "Без точка",
        "noPointSub": "само присъединяване или изтриване"
      }
    }
  },
  "branding": {
    "title": "Оформление",
    "intro": "Вашият цвят, вашето лого и къде клиентите четат условията. Това виждат пътниците и шофьорите ви.",
    "primaryColor": "Основен цвят",
    "primaryColorHint": "Бутоните и акцентите — тук и в двете приложения. Конзолата се променя веднага; телефонът научава новия цвят при следващото отваряне на приложението и го показва от стартирането след това. Цветовете за опасност, предупреждение и потвърждение са фиксирани — те носят значение, а не идентичност.",
    "termsUrl": "Общи условия",
    "privacyUrl": "Политика за поверителност",
    "urlHint": "Трябва да започва с https.",
    "logo": "Лого",
    "logoHint": "PNG, JPEG или WebP, до 512 KB. Показва се на екрана за вход и в заглавната лента.",
    "chooseLogo": "Изберете файл",
    "uploadLogo": "Качване",
    "uploading": "Качва се…",
    "removeLogo": "Премахване",
    "noLogo": "Още няма лого.",
    "saved": "Записано",
    "couldNotLoad": "Оформлението не можа да бъде прочетено.",
    "couldNotSave": "Оформлението не можа да бъде записано.",
    "couldNotUpload": "Логото не можа да бъде качено.",
    "firmTitle": "Вашата фирма",
    "firmIntro": "Името, което виждат пътниците и шофьорите ви. Кодът на фирмата до него е постоянен; това име не е.",
    "displayName": "Име на фирмата",
    "displayNameHint": "Показва се в приложенията и на екрана за вход. Брандирано приложение пази името, с което е издадено.",
    "linesTitle": "Телефонни линии",
    "linesIntro": "Номерата, на които звънят клиентите, в реда, в който искате да се четат. Пътниците виждат тези, които им покажете; отбелязаната линия е тази, на която звънят двете приложения, когато нещо не е наред.",
    "lineLabel": "Етикет",
    "lineNumber": "Номер",
    "lineKind": "Вид",
    "lineShown": "Видима за пътниците",
    "lineSupport": "Приложенията звънят на нея",
    "addLine": "Добавяне на линия",
    "removeLine": "Премахване",
    "noLines": "Още няма линии. Добавете тази, на която звънят клиентите.",
    "lineKinds": {
      "Booking": "Линия за поръчки",
      "Mobile": "Мобилен",
      "Office": "Офис",
      "WhatsApp": "WhatsApp",
      "Viber": "Viber"
    },
    "aboutTitle": "За фирмата",
    "aboutIntro": "Няколко изречения за пътниците, и къде и кога може да ви намерят.",
    "aboutUs": "За нас",
    "aboutUsHint": "До шестстотин знака, показва се в приложението за пътници.",
    "website": "Уебсайт",
    "email": "Имейл за контакт",
    "emailHint": "Публичен адрес, различен от този, с който влизате.",
    "openingHours": "Работно време",
    "openingHoursHint": "Като текст: 24/7 или изречение.",
    "officeAddress": "Адрес на офиса",
    "officeAddressHint": "Показва се на пътниците, никога не се навигира до него.",
    "couldNotLoadProfile": "Профилът на фирмата не можа да бъде прочетен.",
    "couldNotSaveProfile": "Профилът на фирмата не можа да бъде записан."
  },
  "appearance": {
    "title": "Как изглеждат телефоните на шофьорите",
    "intro": "Това го решава офисът, а не шофьорът — телефонът в колата е работен инструмент и приложението няма собствена настройка за това. По подразбиране тъмно, защото бял екран на стойката през нощта се отразява в стъклото. Ако един шофьор има нужда от друго, това се задава в раздел „Автопарк“ и неговата настройка има предимство пред тази.",
    "driverApp": "Приложение на шофьора",
    "driverAppHelp": "„Системна“ следва това, което всеки шофьор е задал на телефона си, и се променя с него по залез. „Светла“ и „Тъмна“ пренебрегват телефона напълно. Шофьор с отворено приложение научава веднага; останалите — при следващото стартиране.",
    "applyToAll": "Приложи за всички шофьори сега",
    "applyHelp": "Записването на настройката по-горе променя това, което следват шофьорите. Това тук изтрива и собствената настройка на всеки отделен шофьор, за да не остане някой с изключение, направено преди месеци.",
    "applyWarning": "Това изтрива настройката за външен вид на всеки шофьор, който има собствена, и не може да бъде отменено. Настройката по-горе се променя и без това.",
    "applied_one": "Готово. Изтрита е собствената настройка на един шофьор.",
    "applied_other": "Готово. Изтрити са собствените настройки на {{count}} шофьори.",
    "appliedToNobody": "Готово. Никой шофьор нямаше собствена настройка, така че нищо не се промени.",
    "apply": "Приложи сега",
    "applyNeedsSave": "Първо запишете настройката по-горе — иначе това ще остави всички шофьори на старата."
  },
  "import": {
    "title": "Клиенти от предишната ви система",
    "intro": "Обаждащите се и адресите, които ползват, пренесени. Нищо не се записва, преди да видите какво ще стане.",
    "format": "Формат",
    "formats": {
      "csv": "CSV",
      "xlsx": "Excel",
      "json": "JSON",
      "telcom": "Телефонен указател на Telcom"
    },
    "formatHint": {
      "csv": "Файл със запетаи или точка и запетая. Колоните се разпознават по заглавията си, на всеки от двата езика.",
      "xlsx": "Електронна таблица, както си е. Форматирайте колоната с телефони като текст преди запис, иначе Excel маха водещата нула.",
      "json": "Масив от хора, всеки със своите адреси.",
      "telcom": "Файлът TelBook на Telcom, точно както е на старата машина."
    },
    "file": "Файл",
    "areaCode": "Код на населеното място",
    "areaCodeHint": "За местните номера, записани без него. Без този код такива редове се отказват, вместо да се гадаят.",
    "preview": "Какво ще стане",
    "commit": "Внасяне наистина",
    "working": "Чете се…",
    "wouldDo": "Какво ще стане",
    "done": "Какво беше направено",
    "rejects": "Редове, които не можаха да бъдат разчетени",
    "truncated": "Изброени са само първите редове. Броевете по-горе са пълни.",
    "row": "Ред",
    "reason": "Причина",
    "value": "Стойност",
    "couldNotRun": "Файлът не можа да бъде прочетен.",
    "count": {
      "read": "Прочетени редове",
      "customersCreated": "Нови клиенти",
      "customersMatched": "Вече познати",
      "addressesAdded": "Добавени адреси",
      "addressesAlreadyKnown": "Вече налични адреси",
      "skipped": "Пропуснати",
      "rejected": "Отказани",
      "addressesRemovedEarlier": "Изтрити преди"
    },
    "chooseFile": "Изберете файл"
  },
  "invite": {
    "title": "Изберете своя парола",
    "intro": "Създаден е акаунт за вас в {{firm}}, за {{email}}. Изберете парола и влизате.",
    "password": "Парола",
    "passwordHint": "Поне дванадесет знака. Дължината е по-важна от препинателните знаци — фраза, която ще запомните, е по-добра парола от къса със символи.",
    "again": "Напишете я отново",
    "submit": "Запази паролата и влез",
    "working": "Запазване…",
    "mismatch": "Двете пароли не съвпадат.",
    "couldNotAccept": "Тази връзка не може да бъде използвана.",
    "askForAnother": "Помолете този, който ви е поканил, да изпрати нова връзка."
  },
  "notStaff": {
    "title": "Този сайт е за офиса",
    "body": "Вашият акаунт тук е на шофьор. Шофьорите работят в приложението за шофьори на фирмата, на телефона си: отворете го и влезте със същия имейл и парола.",
    "signOut": "Изход"
  },
  "fleet": {
    "couldNotLoad": "Автопаркът не можа да бъде прочетен.",
    "couldNotSave": "Промяната не можа да бъде запазена.",
    "edit": "Промени",
    "save": "Запази",
    "cancel": "Откажи",
    "remove": "Премахни",
    "owner": {
      "Driver": "Шофьор",
      "Vehicle": "Автомобил"
    },
    "expiring": {
      "title": "Изтичащи документи",
      "help": "Документи, които скоро ще спрат някого от работа. Шофьор с изтекла книжка не може да излезе на смяна, така че този списък е начинът да разберете предварително, а не в шест сутринта.",
      "none": "Нищо не изтича през следващия месец.",
      "expired_one": "Изтекъл на {{date}} — преди {{count}} ден",
      "expired_other": "Изтекъл на {{date}} — преди {{count}} дни",
      "inDays_one": "Изтича на {{date}} — остава {{count}} ден",
      "inDays_other": "Изтича на {{date}} — остават {{count}} дни"
    },
    "drivers": {
      "title": "Шофьори",
      "help": "Всички в списъка. Напусналият остава, защото завършените му курсове са негови и това е единственият екран, от който може да се върне.",
      "none": "Още няма шофьори.",
      "hire": "Назначи шофьор",
      "hiring": "Назначаване на шофьор",
      "editing": "Промяна на шофьор",
      "email": "Имейл адрес",
      "emailHelp": "Получава връзка и сам избира паролата си. Ако вече има акаунт тук или в друга фирма в системата, се използва той и не се изпраща нищо.",
      "name": "Име",
      "nameHelp": "Това виждат диспечерите и пътниците.",
      "phone": "Телефон",
      "phoneHelp": "Диспечерите звънят на шофьорите постоянно.",
      "callSign": "Кратък номер",
      "callSignHelp": "Краткият номер, с който колата се назовава по радиостанцията, ако фирмата ползва такива.",
      "notes": "Бележки",
      "notesHelp": "За диспечерите: предпочита летището, без кеш.",
      "noNumber": "без телефон",
      "noVehicle": "без кола",
      "offboard": "Напуснал е",
      "reinstate": "Върни на работа",
      "invited": "Изпратена е покана до {{email}}.",
      "existingAccount": "{{email}} вече има акаунт, така че не е изпратено нищо — влиза с паролата, която има.",
      "offboarded": "{{name}} е свален от списъка. Сесиите му са прекратени, а ролята му е спряна.",
      "offboardedKeepsRole": "{{name}} е свален от списъка и сесиите му са прекратени. Има и друга роля тук, затова достъпът до конзолата е запазен.",
      "reinstated": "{{name}} отново е в списъка.",
      "settings": "Настройки",
      "appTheme": "Външен вид на приложението",
      "appThemeHelp": "Как изглежда приложението на този шофьор. „Като на фирмата“ означава {{firm}} днес и се променя, ако фирмата промени решението си. Всичко останало важи само за него.",
      "followsFirm": "Като на фирмата",
      "hasAppThemeOverride": "собствен външен вид"
    },
    "vehicles": {
      "title": "Автомобили",
      "help": "Всички коли. Спряната от движение остава в списъка, за да може да бъде върната.",
      "none": "Още няма регистрирани коли.",
      "register": "Регистрирай кола",
      "registering": "Регистриране на кола",
      "editing": "Промяна на кола",
      "plate": "Регистрационен номер",
      "plateHelp": "Пишете го както ви е удобно — интервалите и главните букви не се броят, CA 1234 AB и ca1234ab са една и съща кола.",
      "makeModel": "Марка и модел",
      "make": "Марка",
      "model": "Модел",
      "colourYear": "Цвят и година",
      "colourHelp": "Цветът различава две еднакви коли в двора.",
      "category": "Клас",
      "categoryHelp": "Какво е колата: по един клас. Определя кои поръчки ѝ се предлагат.",
      "featuresHelp": "Всичко, което колата може да вземе или направи. Изберете колкото искате; поръчка, която иска някое, отива само при коли с него.",
      "seatsLabel": "Пътнически места",
      "seatsHelp": "Без шофьора.",
      "seats_one": "{{count}} място",
      "seats_other": "{{count}} места",
      "notes": "Бележки",
      "nobodyInIt": "няма шофьор",
      "retire": "Спри от движение",
      "restore": "Върни в движение",
      "colour": "Цвят",
      "year": "Година",
      "features": "Какво предлага"
    },
    "documents": {
      "title": "Документи",
      "none": "Няма записани документи.",
      "record": "Запиши",
      "kind": "Документ",
      "description": "Какъв е",
      "descriptionHelp": "Само за документи, за които системата няма име.",
      "number": "Номер",
      "dates": "Издаден и изтича",
      "datesHelp": "Датата на изтичане е важната — проверява се при всяко излизане на смяна. Оставете я празна за документ без срок.",
      "expiresOn": "Изтича на",
      "valid": "валиден до {{date}}",
      "expiringSoon": "изтича на {{date}}",
      "expired": "изтекъл на {{date}}",
      "noExpiry": "без срок",
      "hasExpired": "изтекли документи",
      "blocking": "Няма валиден документ {{kind}}, така че излизане на смяна не е възможно.",
      "issuedOn": "Издаден на"
    },
    "documentKinds": {
      "DrivingLicence": "Свидетелство за управление",
      "TaxiDriverCertificate": "Удостоверение за таксиметров водач",
      "MedicalCertificate": "Медицинско свидетелство",
      "VehicleRegistration": "Талон на автомобила",
      "Insurance": "Застраховка",
      "RoadworthinessCertificate": "Годишен технически преглед",
      "TaxiPermit": "Разрешение за таксиметров превоз",
      "Other": "Друго"
    },
    "staff": {
      "title": "Служители в офиса",
      "help": "Кой приема обажданията и кой настройва фирмата. Канят се по имейл адрес, точно както и вие — избират си паролата сами от връзката.",
      "none": "Още няма служители.",
      "inviting": "Поканете някого",
      "invite": "Изпрати поканата",
      "email": "Имейл адрес",
      "emailHelp": "Ако вече има акаунт тук или в друга фирма в системата, се използва той и не се изпраща нищо.",
      "name": "Име",
      "roles": "Какво може да прави",
      "role": {
        "Dispatcher": "Приема обаждания и изпраща коли",
        "TenantAdmin": "Настройва фирмата"
      },
      "suspend": "Отнеми достъпа",
      "invited": "Изпратена е покана до {{email}}.",
      "existingAccount": "{{email}} вече има акаунт, така че не е изпратено нищо — влиза с паролата, която има.",
      "suspended": "Достъпът на {{name}} е отнет. Телефонният му вътрешен номер също."
    },
    "close": "Затвори",
    "columns": {
      "who": "Кой",
      "expires": "Изтича",
      "name": "Име",
      "phone": "Телефон",
      "car": "Кола",
      "state": "Състояние",
      "plate": "Рег. номер",
      "seats": "Места",
      "driver": "Шофьор",
      "roles": "Права"
    },
    "telephone": {
      "open": "Телефон",
      "title": "Телефонът на {{name}}",
      "answerOn": "Вдига на",
      "answerOnHelp": "Телефонът, който звъни първи. Диспечерът може да го смени сам от конзолата.",
      "ringOther": "Звъни на другия телефон, когато този не е достъпен",
      "alsoRingOther": "Звъни и на другия телефон, ако този не е вдигнат след",
      "whenOnACall": "Когато вече е в разговор",
      "whenOnACallHelp": "Показването на второто обаждане му позволява да го вдигне; вдигането задържа първия клиент в телефонната система, откъдето всеки може да го поеме.",
      "showAndTake": "Покажи го и му позволи да го вдигне",
      "sendToOthers": "Зает: прати го на друг",
      "lines": "Линии",
      "linesHelp": "Кои от номерата на фирмата звънят за него. Обаждане, което никой с тази линия не може да поеме, пак звъни на всички, които могат.",
      "allLines": "Всички линии на фирмата",
      "noLines": "Фирмата няма зададени номера в настройките на телефонията."
    },
    "allowed": {
      "sectionTitle": "Кой какво кара",
      "sectionHelp": "Дали шофьорът влиза във всяка свободна кола, или само в колите, които му разрешите. Така никой не тръгва с кола, за която няма застраховка или категория.",
      "anyCar": "Шофьорите може да вземат всяка свободна кола",
      "anyCarOn": "Всеки шофьор вижда всички свободни коли в приложението си. Разрешените на всеки коли се пазят за момента, в който изключите това.",
      "anyCarOff": "Шофьорът вижда само разрешените му коли и не може да влезе в друга. Изберете ги в колона „Кола“ на всеки шофьор.",
      "title": "Коли, които {{name}} може да кара",
      "help": "Изберете всяка кола, в която този шофьор може да влиза. Една кола може да е на няколко шофьори — дневна и нощна смяна.",
      "cars": "Коли",
      "none": "Още няма разрешени коли",
      "choose": "Избери коли",
      "count_one": "{{count}} кола",
      "count_other": "{{count}} коли",
      "find": "Намерете кола по номер, марка или модел"
    }
  },
  "mfa": {
    "title": "Въведете кода",
    "code": "Код",
    "codeHint": "Шест цифри от приложението за автентикация или един от кодовете за възстановяване.",
    "submit": "Продължи",
    "checking": "Проверка…",
    "startAgain": "Започни отначало",
    "couldNotStart": "Настройката на автентикатор не можа да започне.",
    "couldNotVerify": "Кодът не можа да бъде проверен.",
    "enrol": {
      "title": "Настройте автентикатор",
      "why": "Този акаунт вижда всички клиенти на фирмата, затова освен парола му трябва и втори фактор. Сканирайте с приложение за автентикация — Google Authenticator, Aegis, 1Password, което ползвате — и въведете кода, който показва.",
      "qrAlt": "QR код с тайната на автентикатора за този акаунт",
      "orType": "Не можете да сканирате? Въведете това в приложението:",
      "codeHint": "Шестте цифри, които приложението показва в момента."
    },
    "recovery": {
      "title": "Кодове за възстановяване",
      "once": "Показват се еднократно и не се пазят никъде, откъдето можем да ги прочетем. Запишете ги или ги сложете в мениджър на пароли, преди да продължите.",
      "what": "Всеки заменя код веднъж. С тях влизате, ако загубите телефона си — иначе някой трябва да ви нулира.",
      "saved": "Запазих ги",
      "copy": "Копирай",
      "copied": "Копирано"
    },
    "reset": "Нулирай автентикатора",
    "resetConfirm": "Да се нулира ли автентикаторът на {{name}}? При следващото влизане ще настрои нов, а всички отворени сесии ще бъдат прекратени.",
    "resetDone": "Готово. {{name}} ще настрои нов автентикатор при следващото влизане."
  },
  "person": {
    "menu": "Вашият профил",
    "you": "Вие",
    "entrances": "Входове",
    "entrancesFirm": "Както е избрала фирмата ({{way}})",
    "entrancesWay": {
      "list": "В списъка",
      "after": "След адреса"
    },
    "numbers": "Номера",
    "numbersWay": {
      "list": "В списъка",
      "after": "След улицата"
    }
  },
  "nav": {
    "views": "Изглед",
    "view": {
      "desk": "Работно място",
      "map": "Карта",
      "timeline": "График"
    },
    "pin": "Отваряй този изглед при вход",
    "pinned": "Отваря се при вход",
    "backToDispatch": "Обратно към диспечера",
    "area": {
      "dispatch": "Диспечер",
      "settings": "Настройки на фирмата",
      "reports": "Справки",
      "whatsNew": "Какво ново"
    },
    "settingsGroup": {
      "dispatch": "Диспечиране",
      "money": "Пари",
      "people": "Хора",
      "firm": "Фирма",
      "simulation": "Симулация",
      "gettingStarted": "Първи стъпки"
    },
    "settings": {
      "setup": "Настройка",
      "dispatch": "Диспечиране",
      "zones": "Зони и стоянки",
      "map": "Карта",
      "prices": "Цени",
      "surcharges": "Нощни и празнични",
      "duty": "Дежурства и такси",
      "fleet": "Автопарк",
      "branding": "Облик",
      "telephony": "Телефони",
      "import": "Внасяне на клиенти",
      "simulation": "Симулация",
      "search": "Търсене на адреси",
      "replay": "Пътувания",
      "driverApp": "Приложение за шофьори",
      "places": "Адреси",
      "labels": "Етикети на поръчките",
      "cancellations": "Причини за отказ",
      "devices": "Устройства"
    },
    "reports": {
      "shift-book": "Дневник на смените",
      "demand": "Кога и къде",
      "service": "Обслужване",
      "clients": "Клиенти",
      "directory": "Картотека",
      "calls": "Разговори",
      "journeys": "Пътувания",
      "addresses": "Адреси за заключване"
    },
    "settingsAbout": {
      "setup": "Доколко фирмата е готова и какво остава.",
      "dispatch": "Как поръчка намира шофьор и какво става, когато не намери.",
      "zones": "Градът, разделен както тази фирма го дели, и стоянките в него.",
      "map": "Къде се отварят картите на фирмата: диспечерската, приложението за пътници, когато телефонът не знае къде е, и редакторът на зони, докато няма зона.",
      "prices": "Колко струва курс, колко струва отказ и как се отчита плащането.",
      "surcharges": "Кога тарифата е по-висока: нощем, в празници и календарът зад тях.",
      "duty": "Какво се брои за отработен ден и колко дължи шофьорът за него.",
      "fleet": "На кого стъпва фирмата: шофьори, коли, документите им и офисът.",
      "branding": "Името и цветът на фирмата и как изглеждат телефоните на шофьорите.",
      "telephony": "Телефонната система и какво чува обаждащият се, докато чака.",
      "import": "Прехвърляне на клиентите и адресите им от старата система на фирмата.",
      "simulation": "Симулираните фирми: ботове, които карат, поръчки, които идват, телефон, който звъни.",
      "search": "Къде диспечерът търси адрес: в града, в околните села и по-далеч. Превключва между трите, докато приема поръчката.",
      "replay": "Колко дълго се пазят пътуванията и какво справката „Пътувания“ смята за проблем.",
      "driverApp": "Какво могат телефоните на шофьорите: съобщения, алармата, топлинната карта, накъде пътува шофьорът, следваща поръчка преди края на текущата, цени и таксиметър.",
      "places": "Адресите на фирмата: входовете и местата, които ги няма на картата — поставени веднъж, заключени и намирани първи при всяко търсене.",
      "labels": "Какво може да поиска една поръчка от колата — багаж, домашен любимец, плащане с карта — и снимката, с която приложението за пътници показва всеки етикет.",
      "cancellations": "Причините, които пътникът може да посочи, когато откаже поръчка в приложението, и редът, в който му се предлагат.",
      "devices": "Служебните телефони и таблети на фирмата и личните телефони на шофьорите: у кого е всяко, кое е свободно и кое е отписано."
    }
  },
  "timeline": {
    "title": "Следващите два часа",
    "now": "сега {{time}}",
    "driver": "Шофьор",
    "onShift_one": "{{count}} на смяна",
    "onShift_other": "{{count}} на смяна",
    "waiting": "Чакащи",
    "orders_one": "{{count}} поръчка",
    "orders_other": "{{count}} поръчки",
    "booked": "Записани",
    "inWindow": "{{count}} в интервала",
    "beyond": "още {{count}} по-късно",
    "searchStarts": "търсенето започва {{time}}",
    "freeSince": "свободен от {{time}}",
    "freeSinceAt": "свободен от {{time}} · на {{rank}}",
    "freeAt": "свободен {{time}}",
    "shiftEnds": "смяната свършва {{time}}",
    "offered": "предложена {{reference}} · {{seconds}} с за отговор",
    "break": "почивка",
    "onCall": "В разговор",
    "newOrderForCaller": "Нова поръчка за този клиент",
    "nobody": "Никой не е на смяна.",
    "unavailable": "Графикът не можа да се зареди.",
    "legend": {
      "ride": "в курс",
      "toPickup": "към клиента",
      "offered": "предложена",
      "break": "почивка",
      "shiftEnds": "край на смяната"
    },
    "strip": {
      "freeNow": "свободни сега",
      "freeWithin15Min": "ще се освободят до 15 мин",
      "waitingOver10Min": "чакат над 10 мин",
      "bookedWithinHour": "записани за следващия час",
      "shiftsEndingWithinHour": "смени, свършващи до час"
    }
  },
  "setup": {
    "sinceTheStart": "самото начало",
    "chip": "Настройка · {{percent}}%",
    "progress": "{{settled}} от {{total}}",
    "percent": "{{percent}}%",
    "intro": "Всичко тук се преценява по това, което фирмата наистина има, никога по отметка. Отбележете каквото не ви трябва и се върнете по всяко време.",
    "complete": "Фирмата ви е настроена.",
    "completeHint": "Всеки елемент е готов или отбелязан като ненужен. Списъкът остава тук като карта на настройките, а отбелязаното като ненужно може да се върне.",
    "couldNotLoad": "Настройката не можа да бъде прочетена.",
    "couldNotSave": "Това не можа да бъде записано.",
    "open": "Отваряне",
    "notNeeded": "Не е нужно",
    "needed": "Все пак е нужно",
    "startGuide": "Започнете водената настройка отново",
    "resumeGuide": "Продължете водената настройка",
    "state": {
      "Todo": "Предстои",
      "InProgress": "В процес",
      "Done": "Готово",
      "NotNeeded": "Не е нужно"
    },
    "group": {
      "beforeFirstBooking": "Преди първата поръчка",
      "face": "Лицето на фирмата",
      "city": "Градът",
      "money": "Пари",
      "customers": "Вашите клиенти",
      "withUs": "Заедно с нас"
    },
    "groupHint": {
      "beforeFirstBooking": "Без тях системата отказва поръчка.",
      "face": "Това, което виждат пътниците и шофьорите.",
      "city": "Как поръчката намира кола.",
      "money": "Какво се таксува и какво дължи шофьорът.",
      "customers": "За да разпознава телефонната централа обаждащите се от първия ден.",
      "withUs": "Настройва се заедно с този, който поддържа платформата. Показва се тук, не се брои."
    },
    "item": {
      "tariff": {
        "title": "Тарифа",
        "why": "Без нея не може да се изчисли или запише цена.",
        "done": "{{name}}, от {{date}}"
      },
      "dispatcher": {
        "title": "Някой да приема обажданията",
        "why": "Диспечер, поканен по имейл. Избира собствена парола от връзката.",
        "done": "{{name}}",
        "inProgress": "Поканен: {{email}}"
      },
      "driver": {
        "title": "Шофьор, който може да застъпи",
        "why": "Нает, с вписана валидна шофьорска книжка. Без нея е отказан при застъпване.",
        "done": "{{name}}"
      },
      "vehicle": {
        "title": "Кола с документи",
        "why": "Регистрирана, с вписана валидна застраховка. В кола без такава не може да се застъпи.",
        "done": "{{plate}}"
      },
      "logo": {
        "title": "Лого",
        "why": "Показва се на екрана за вход, в заглавната лента и в двете приложения.",
        "done": "Качено"
      },
      "lines": {
        "title": "Телефонни линии",
        "why": "Номерата, на които звънят пътниците, и този, на който звънят двете приложения.",
        "done": "{{count}} видими за пътниците"
      },
      "about": {
        "title": "За фирмата",
        "why": "Няколко изречения, които пътниците четат в приложението.",
        "done": "Написано"
      },
      "legal": {
        "title": "Общи условия и поверителност",
        "why": "Приложението за пътници показва и двете, а магазините ги очакват.",
        "done": "И двете са зададени"
      },
      "mapHome": {
        "title": "Къде сте на картата",
        "why": "Всяка карта се отваря тук. Взема се от най-голямата ви зона, ако имате; иначе преместете малката карта до града си и запазете.",
        "done": "{{source}}"
      },
      "zones": {
        "title": "Зони и стоянки",
        "why": "Без тях поръчките се предлагат в разширяващи се кръгове, което работи.",
        "done": "{{count}} зони",
        "notNeededAs": "Диспечираме по разстояние"
      },
      "addressSearch": {
        "title": "Къде се търсят адреси",
        "why": "Очертайте града и диспечерът търси първо там, с превключвател за селата и по-далеч. Без това всяко търсене обхваща цялата страна.",
        "done": "Очертани {{count}} от 3 нива",
        "notNeededAs": "Търсим навсякъде"
      },
      "autoDispatch": {
        "title": "Автоматично диспечиране, решено",
        "why": "Изключено, докато не се доверите на конзолата. Включете го или кажете, че назначавате ръчно.",
        "done": "Включено",
        "notNeededAs": "Назначаваме ръчно"
      },
      "surcharges": {
        "title": "Нощни и празнични тарифи",
        "why": "Важи едва в десет вечерта и в дните, които посочите.",
        "done": "{{rules}} правила, {{holidays}} празници"
      },
      "duty": {
        "title": "Колко струва един ден",
        "why": "Важи едва когато се разплаща първият месец — но преди това, не след.",
        "done": "{{amount}} {{currency}} на ден"
      },
      "fees": {
        "title": "Такси за отказ и неявяване, решени",
        "why": "И двете започват от нула, тоест не таксувате. Кажете го или задайте сума.",
        "done": "Зададени",
        "notNeededAs": "Не таксуваме"
      },
      "customers": {
        "title": "Клиенти от старата система",
        "why": "Внесени от файл, за да познава бюрото обаждащите се от първия ден, а не след месец.",
        "done": "{{count}} клиенти",
        "notNeededAs": "Започваме на чисто"
      },
      "telephony": {
        "title": "Телефонната система",
        "why": "Пуска се заедно с този, който поддържа платформата. Отмята се само, когато конзолата чуе централата.",
        "done": "Свързана",
        "inProgress": "Настроена, чака се централата"
      }
    },
    "guide": {
      "stepOf": "Стъпка {{step}} от {{total}}",
      "back": "Назад",
      "next": "Напред",
      "skip": "Пропусни тази стъпка",
      "notNow": "Не сега",
      "start": "Да започваме",
      "finish": "Отваряне на списъка",
      "toDesk": "Отваряне на бюрото",
      "saving": "Записва се…",
      "welcome": {
        "title": "Добре дошли, {{firm}}",
        "body": "Системата ви вече работи: бюрото е отворено и може да се приемат обаждания. Тези екрани отнемат около пет минути и я правят ваша. Всичко може да се пропусне и да се довърши по-късно от Настройки → Настройка."
      },
      "firm": {
        "title": "Вашата фирма",
        "body": "Името, логото и цветът, които виждат пътниците и шофьорите ви.",
        "preview": "Как ще изглежда заглавната лента на конзолата"
      },
      "reach": {
        "title": "Как ви намират клиентите",
        "body": "Линиите, на които звънят, няколко думи за вас и къде сте."
      },
      "people": {
        "title": "Вашите хора",
        "body": "Поканете диспечер по имейл. Той избира собствена парола от връзката. Фирма с един човек може да пропусне това.",
        "email": "Имейл",
        "name": "Име",
        "dispatcher": "Диспечер",
        "admin": "Управител",
        "invite": "Изпращане на поканата",
        "sent": "Изпратени покани",
        "invited": "Изпратена до {{email}}",
        "existing": "{{email}} вече имаше акаунт, така че нищо не е изпратено; влиза с паролата, която има."
      },
      "done": {
        "title": "Основното е готово",
        "body": "Ето какво още стои между вас и първата поръчка, и какво се отплаща по-късно. Всичко от списъка може да се довърши в произволен ред от Настройки → Настройка."
      }
    }
  },
  "desks": {
    "which": "На кое бюро сте?",
    "whichHelp": "Телефоните му ще звънят за вас. Този компютър помни отговора; сменя се от менюто на телефона.",
    "takenBy": "там е {{name}}",
    "none": "Без бюро",
    "desk": "Бюро",
    "yours": "Вашето бюро: {{desk}} · {{extension}}",
    "couldNotChoose": "Бюрото не можа да бъде избрано."
  },
  "parked": {
    "title": "На изчакване",
    "heldBy": "задържан от {{name}} · {{time}}",
    "somebody": "някого",
    "take": "Поеми",
    "couldNotTake": "Клиентът не можа да бъде поет.",
    "order": "Поръчка {{reference}}"
  },
  "phoneLines": {
    "title": "Линии",
    "help": "SIM картите в гейтуея и транкът, както ги знае централата. Добавянето тук е това, което ги създава в централата — с името и паролата, въведени тук, същите, които се въвеждат и в страницата на гейтуея. Гейтуей, настроен като един акаунт за цялата кутия, е една линия; гейтуей, чиито SIM карти се регистрират всяка със свой акаунт, е по една линия на SIM — и само тогава разговор може да излезе през определена SIM карта. Транк от доставчик, настроен в собствените настройки на централата — например стационарна линия, която идва по отделна линия — се добавя с името си и без парола: показва се тук такъв, какъвто е, и нищо не се записва в централата.",
    "add": "Добави линия",
    "none": "Все още няма линии. Разговорите продължават да пристигат по това, което е настроено на ръка в централата; избройте ги тук, за да ги наименувате и да избирате по коя излиза разговор.",
    "label": "Наричана",
    "labelHelp": "Както я нарича офисът, например SIM 3 — A1.",
    "name": "Име в централата",
    "nameHelp": "Малки латински букви, цифри, тирета и долни черти, започва с буква: gsm-goip, или gsm-goip-3 за една SIM карта на гейтуей, настроен по линии. Това е името на акаунта, с който гейтуеят се регистрира, и не може да се сменя след това. Започнете името на SIM линия с думата от „SIM линиите се казват“.",
    "number": "Номер",
    "numberHelp": "Номерът, който клиентът вижда, когато разговор излезе по тази линия. При линия на всяка SIM карта по него се разпознава и входящото обаждане, затова го попълнете.",
    "kind": "Вид",
    "kindHelp": "SIM картата носи по един разговор, затова клиент никога не се оставя да чака на нея.",
    "kinds": {
      "Sim": "SIM",
      "Trunk": "Транк"
    },
    "address": "Адрес",
    "addressHelp": "Само за гейтуей, регистриран като един акаунт за цялата кутия: фиксираният му адрес в офисната мрежа, защото такъв гейтуей изпраща номера на обаждащия се там, където трябва да е собственото му име. Оставете празно при линия на всяка SIM карта и попълнете номера: гейтуеят препраща обажданията на всяка карта към собствения ѝ номер и по него централата ги различава.",
    "byName": "по име",
    "dialPrefix": "Префикс за набиране",
    "dialPrefixHelp": "Само при линия на всяка SIM карта: Routing Prefix на гейтуея за тази линия, който се слага пред всеки набран по нея номер и гейтуеят го маха. Без него такъв гейтуей отказва разговора, защото не знае за коя карта е.",
    "password": "Парола",
    "passwordHelp": "С каквото гейтуеят се регистрира. Въведете същата и в страницата на гейтуея. Записва се в централата и никъде другаде. Оставете празно за транк, вече настроен в собствените настройки на централата: централата се пита дали има линия с това име и тя се добавя такава, каквато е.",
    "passwordKeepHelp": "Оставете празно, за да запазите тази в централата. Въведете нова, за да я смените — гейтуеят спира да се регистрира, докато не получи същата.",
    "state": "Гейтуей",
    "registered": "Регистриран",
    "notRegistered": "Не е регистриран",
    "inPbxConfiguration": "В настройките на централата",
    "inPbxConfigurationHelp": "Тази линия е настроена в собствените настройки на централата, където е и как се свързва. Тук се променят името ѝ за офиса, номерът, видът и префиксът; нищо не се записва в централата.",
    "edit": "Редактирай",
    "editTitle": "Редактиране на {{label}}",
    "remove": "Премахни",
    "removeConfirm": "Да се премахне ли {{label}} ({{name}})? Спира да работи веднага. Разговорите, дошли по нея, запазват името ѝ в дневника.",
    "removeFromListConfirm": "Да се премахне ли {{label}} ({{name}}) от списъка? Централата я запазва, но вече не може да се избира за изходящи разговори. Разговорите, дошли по нея, запазват името ѝ в дневника."
  },
  "deskPhones": {
    "title": "Бюра и настолни телефони",
    "help": "Бюрото е мястото на диспечера, с един или повече апарата на него. Всеки апарат поема едно обаждане, получава собствен номер от 7500 и показва паролата си веднъж, за да се въведе в телефона. Който е на бюрото, държи всичките му телефони; звъни първият свободен. Редът на бюрата е редът, по който обажданията стигат до тях.",
    "none": "Все още няма бюра. Диспечерите вдигат в браузъра.",
    "name": "Име",
    "nameHelp": "Както го наричат в офиса, например Бюро 1.",
    "extension": "Номер",
    "givenTo": "Даден на",
    "atIt": "На него сега",
    "state": "Телефон",
    "nobody": "Никой",
    "reachable": "Свързан",
    "unreachable": "Не е свързан",
    "newPassword": "Нова парола",
    "remove": "Премахни",
    "removeConfirm": "Да се премахне ли {{name}} ({{extension}})? Спира да работи веднага, а номерът никога не се дава на друг телефон.",
    "typeIntoIt": "Въведете това в {{name}}",
    "typedIt": "Въведох ги",
    "shownOnce": "Паролата се показва само сега. Ако се загуби, дайте на телефона нова.",
    "server": "Сървър",
    "serverUnset": "Задайте „Адрес, към който се регистрират настолните телефони“ по-горе",
    "userName": "Потребител",
    "password": "Парола",
    "whereToType": "На Yealink: уеб страницата му, Account → Register. Потребителят се въвежда и в Register Name, и в User Name.",
    "notFetchedYet": "още не е изтеглил",
    "fetchedAt": "изтеглил {{when}}",
    "setUp": "Самонастройка",
    "setUpTitle": "{{name}} се настройва сам",
    "sendSettings": "Изпрати настройките сега",
    "sent": "Изпратено. Телефонът изтегля настройките си до няколко секунди, без да се рестартира.",
    "mac": "MAC адрес",
    "macHelp": "От етикета на гърба на телефона. Оставете празно, за да спре да се настройва сам.",
    "noAddress": "Този сървър няма адрес, до който телефоните да стигат. Задава го доставчикът ви.",
    "address": "Адрес на сървъра",
    "whereToTypeAddress": "На Yealink: уеб страницата му, Settings → Auto Provision → Server URL, после Save и Auto Provision Now. Нищо друго не се въвежда: телефонът изтегля акаунта си, нова парола и останалото. Същият адрес може да се даде на всички телефони наведнъж от рутера на офиса — DHCP опция 66.",
    "addDesk": "Добави бюро",
    "addDeskHelp": "Бюрото получава първия си телефон сега, със същото име.",
    "addPhone": "Добави телефон",
    "addPhoneTitle": "Добави телефон на {{desk}}",
    "phoneNameHelp": "Какво показва екранът му, например {{desk}} · 2.",
    "noPhones": "На бюрото още няма телефони.",
    "desk": "Бюро",
    "moveUp": "Нагоре",
    "moveDown": "Надолу",
    "moveTo": "Бюро",
    "renameDesk": "Преименувай",
    "renameDeskTitle": "Преименувай {{name}}",
    "removeDesk": "Премахни бюрото",
    "removeDeskConfirm": "Да се премахне ли бюрото {{name}}? На него няма телефони, а който е на него, остава без бюро."
  },
  "pager": {
    "range": "{{first}}–{{last}} от {{total}}",
    "previous": "Предишни",
    "next": "Следващи"
  },
  "counts": {
    "bookings_one": "{{shown}} поръчка",
    "bookings_other": "{{shown}} поръчки",
    "destinations_one": "{{shown}} цел",
    "destinations_other": "{{shown}} цели",
    "addresses_one": "{{shown}} адрес",
    "addresses_other": "{{shown}} адреса",
    "callers_one": "{{shown}} клиент",
    "callers_other": "{{shown}} клиенти",
    "callersAddresses_one": "{{shown}} адрес на клиент",
    "callersAddresses_other": "{{shown}} адреса на клиенти"
  },
  "layout": {
    "divider": "Разделител между работното място и картата — влачете, стрелки наляво/надясно, двойно щракване връща началната ширина"
  },
  "whatsNew": {
    "title": "Какво ново",
    "releasedOn": "Издадено на {{date}}",
    "unread": "Има нова версия — вижте какво ново",
    "view": "Как да се чете",
    "viewBoard": "Табло",
    "viewPage": "Страница",
    "viewCards": "Карти",
    "atAGlance": "{{month}} накратко",
    "previous": "Назад",
    "next": "Напред",
    "cardOf": "{{at}} от {{total}}"
  },
  "form": {
    "enterANumber": "Въведете число",
    "enterANumberFrom": "Въведете число, най-малко {{min}}",
    "atLeast": "Най-малко {{min}}",
    "atMost": "Най-много {{max}}",
    "tooPrecise": "Твърде много цифри след десетичната запетая",
    "oneField": "Не е запазено. {{label}}: {{message}}",
    "severalFields_one": "Не е запазено. {{count}} поле трябва да се поправи, маркирано е в червено: {{labels}}",
    "severalFields_other": "Не е запазено. {{count}} полета трябва да се поправят, маркирани са в червено: {{labels}}"
  },
  "replay": {
    "keepTitle": "Пазене на пътуванията",
    "keepHelp": "Пътуването е запис къде е бил шофьорът, минута по минута. Пази се толкова след края на поръчката и после се изтрива заедно с маршрута, по който е изчислена цената. Нова стойност важи за пътуванията отсега нататък, никога за вече пазените.",
    "retentionDays": "Пази пътуванията",
    "retentionDaysHelp": "Достатъчно за жалба, застраховател и бавно полицейско запитване. Обикновено половин година.",
    "problemsTitle": "Какво е проблем",
    "problemsHelp": "Справката „Пътувания“ отбелязва курс според тези стойности. Промяната на някоя преоценява всички курсове по новото правило; нищо записано не се променя.",
    "lateMinutes": "Закъснение след",
    "lateMinutesHelp": "Минути след очакваното време: часа на предварителната поръчка или времето по маршрута от мястото, където шофьорът я е поел.",
    "detourPercent": "Обиколен път, ако е по-дълъг с",
    "detourPercentHelp": "С колко процента курсът може да е по-дълъг от най-краткия път.",
    "detourMinimumMetres": "…и поне с",
    "detourMinimumMetresHelp": "За да не е обиколка кратък курс, заобиколил едно каре, само защото карето е една трета от него.",
    "longWaitMinutes": "Дълго чакане след",
    "longWaitMinutesHelp": "Минути, през които колата е чакала клиента на адреса.",
    "longStopMinutes": "Спиране по пътя след",
    "longStopMinutesHelp": "Минути на място, където поръчката не е искала спиране — не на адреса, на спирка или в крайната точка.",
    "inTownSpeedKmh": "Превишена скорост в града над",
    "inTownSpeedKmhHelp": "В града, който сте очертали в Настройки → Търсене на адреси. Ако не сте очертали град, целият курс се съди по това ограничение.",
    "outOfTownSpeedKmh": "Превишена скорост извън града над",
    "outOfTownSpeedKmhHelp": "Всеки път извън града, включително магистралите: приложението не знае по кой път е била колата — само дали е била в града.",
    "unitPercent": "%",
    "unitKmh": "км/ч"
  },
  "driverApp": {
    "groupTalk": "Връзка с офиса",
    "groupTalkHelp": "Двете неща, които шофьорът може да изпрати, без да се обажда.",
    "messagingEnabled": "Съобщения",
    "messagingEnabledHelp": "Шофьорите и диспечерите си разменят кратки съобщения в приложението, с готови фрази и от двете страни. Изключено — всяка дума минава по телефона.",
    "alarmEnabled": "Тиха аларма",
    "alarmEnabledHelp": "Скрит бутон, който шофьорът задържа; всеки диспечер вижда червена лента с колата, номера и поръчката, и някой я изчиства.",
    "groupOffers": "Кой какво получава",
    "groupOffersHelp": "Два превключвателя, които променят как се избира кола. И двата са изключени в началото.",
    "headingHomeEnabled": "Шофьорът казва накъде пътува",
    "headingHomeEnabledHelp": "Шофьорът избира адрес от телефона — или дома си, запазен веднъж, с едно докосване — и получава само поръчки, чиято крайна точка го приближава натам. Поръчка без крайна точка не му се предлага, докато е така.",
    "nextJobEnabled": "Следваща поръчка преди края на текущата",
    "nextJobEnabledHelp": "Кола с пътник и няколко минути път се смята за кола, спряла на крайната си точка, и може да получи поръчка наблизо. Шофьорът отговаря на екрана, с който кара.",
    "nextJobMinutesBeforeFree": "Минути преди слизането",
    "nextJobMinutesBeforeFreeHelp": "Колко близо до слизането трябва да е колата, за да ѝ се предложи следващата поръчка. Пет са последните улици от пътуването.",
    "groupStreet": "Пътници от улицата",
    "groupStreetHelp": "Повечето курсове започват на улицата или на стоянката. С това включено те са курсове като всички останали.",
    "streetRidesEnabled": "Шофьорът записва пътниците, които качва сам",
    "streetRidesEnabledHelp": "Един бутон в телефона на шофьора отваря курса с качен пътник: спират да му се предлагат поръчки, излиза от стоянката, книгата на смените брои курса с показанието на апарата, а пътник, дал номера си, намира разписката в приложението за пътници. Изключено — шофьор, качил пътник, е в почивка, доколкото офисът вижда.",
    "groupShows": "Какво показва телефонът",
    "groupShowsHelp": "Какво вижда шофьорът освен смяната и поръчките си.",
    "heatmapEnabled": "Топлинна карта",
    "heatmapEnabledHelp": "Къде има работа: вашите зони с чакащите поръчки и колите във всяка. Само бройки, никога къде е колега.",
    "ratePassengersEnabled": "Оценка на клиента",
    "ratePassengersEnabledHelp": "След курс шофьорът дава оценка и дума, които се показват до номера при следващото обаждане.",
    "showFares": "Показвай цените",
    "showFaresHelp": "Приблизителната цена на предложението и на курса, и изчислената цена до показанието на апарата накрая. Апаратът в колата остава това, което клиентът плаща.",
    "taximeterEnabled": "Таксиметър в телефона",
    "taximeterEnabledHelp": "С пътник в колата телефонът брои време и разстояние и показва текуща цена по вашата тарифа, отбелязана като ориентировъчна. Пломбираният апарат в колата остава меродавен.",
    "groupPlaces": "Адресите на фирмата",
    "groupPlacesHelp": "Шофьорите помагат да се поставят входовете, които ги няма на картата.",
    "rememberEntrancesEnabled": "Шофьорите запомнят входове",
    "rememberEntrancesEnabledHelp": "Когато поръчката посочва вход, който никой не е поставил, шофьорът е питан пред вратата дали да запомни мястото, а заключено място може да бъде отбелязано като грешно. Мястото се запазва, след като пътникът се качи, и чака одобрението на администратора.",
    "groupDevices": "Улеснен достъп",
    "groupDevicesHelp": "Шофьорът влиза без имейл и парола — от служебно устройство или от личния си телефон, регистриран веднъж от офиса. Служебните се регистрират и дават от „Устройства“, а личният телефон се добавя от „Автопарк“ → шофьора → „Устройства“, с QR код.",
    "serviceDeviceRequestsEnabled": "Телефон може да поиска улеснен достъп",
    "serviceDeviceRequestsEnabledHelp": "В приложението на шофьора, под „Улеснен достъп“, има бутон „Изпрати заявка за регистрация“. Телефонът показва четирицифрен код, а при администратора излиза известие с този код. Той избира или създава шофьора и колата и одобрява — телефонът става личен телефон на шофьора. Изключено — личен телефон се добавя само с QR кода от прозореца на шофьора."
  },
  "messages": {
    "title": "Съобщения",
    "unread_one": "{{count}} ново съобщение",
    "unread_other": "{{count}} нови съобщения",
    "unreadHint": "Думи от шофьорите, които никой не е прочел. Отваря бюрото.",
    "writeTo": "Пиши на…",
    "empty": "Никой шофьор не е писал още. Изберете на кого да пишете.",
    "nothingYet": "Още нищо.",
    "close": "Затвори",
    "send": "Изпрати",
    "read": "прочетено",
    "placeholder": "Пишете на шофьора… Enter изпраща.",
    "sendFailed": "Съобщението не можа да се изпрати. Опитайте пак.",
    "presets": "Готови фрази"
  },
  "alarms": {
    "raised": "{{driver}} вдигна аларма в {{time}}",
    "noPhone": "няма номер",
    "onOrder": "по {{reference}}",
    "showOnMap": "Покажи на картата",
    "clear": "Изчисти"
  },
  "places": {
    "building": "Адрес",
    "buildingHelp": "Както се казва, без входа: Студентска 14 или ж.к. Дружба 3, бл. 12.",
    "entrance": "Вход",
    "note": "Бележка за диспечера и шофьора",
    "noteHelp": "Какво да се знае там: входът е откъм двора, звънецът не работи.",
    "names": "Други имена",
    "namesHelp": "Разделени със запетая: Автогарата, сива кооп. Всяко от тях намира адреса.",
    "add": "Добави",
    "export": "Изтегли CSV",
    "saved": "{{line}} е запазен.",
    "deleted": "Адресът е премахнат.",
    "openExisting": "Отвори го",
    "confirmRemoveTitle": "Да изтрия ли адреса?",
    "confirmRemove": "{{line}} изчезва от всяко търсене, заедно с историята си. Поръчките, вече взети до него, си остават.",
    "notice_one": "{{count}} адрес чака вашето одобрение.",
    "notice_other": "{{count}} адреса чакат вашето одобрение.",
    "noticeOpen": "Прегледай",
    "noticeLater": "По-късно",
    "source": {
      "administrator": "Администратор",
      "dispatcher": "Диспечер",
      "driver": "Шофьор"
    },
    "map": {
      "door": "Вход",
      "stop": "Къде спира колата",
      "clickDoor": "Щракнете на картата там, където е входът.",
      "clickStop": "Щракнете на картата там, където да спира колата."
    },
    "lock": {
      "open": "Заключи…",
      "move": "Премести…",
      "title": "Заключи адреса",
      "moveTitle": "Премести адреса",
      "about": "Поставете входа на картата и от сега нататък всяко търсене ще го намира — бюрото, приложението за пътници и шофьорите.",
      "moveAbout": "Преместете входа на този адрес. Бележката и имената му остават.",
      "clickTheDoor": "Щракнете на картата там, където е входът.",
      "noPoint": "Първо изберете адреса от списъка, за да знае картата къде да се отвори.",
      "save": "Заключи",
      "useIt": "Вземи този адрес",
      "moveHere": "Премести го тук"
    },
    "settings": {
      "title": "Кой поставя адреси",
      "dispatchers": "Диспечерите заключват адреси",
      "dispatchersHelp": "Диспечерът може да постави адрес от поръчката и да премести вече поставен. Ползва се веднага и чака вашето одобрение; изтриването е само ваше.",
      "entrances": "Как бюрото предлага входовете",
      "entrancesHelp": "В списъка всеки вход е отделен ред. След адреса сградата е един ред, а буквите на входовете се появяват, щом бъде избрана. Всеки диспечер може да избере другия начин за себе си."
    },
    "review": {
      "title_one": "{{count}} чака одобрение",
      "title_other": "{{count}} чакат одобрение",
      "about": "Поставени или променени от диспечер или шофьор и вече в употреба. Одобрението ги запазва, отхвърлянето ги отменя. Сигнал от шофьор не мести нищо, докато не се съгласите.",
      "added": "Нов",
      "changed": "Променен",
      "reported": "Шофьор: грешно място",
      "reportSpot": "Пътникът се е качил на {{metres}} м оттук.",
      "reportNoSpot": "Пътникът не е дошъл; няма посочено място.",
      "before": "Къде беше",
      "show": "Покажи",
      "approve": "Одобри",
      "reject": "Отхвърли",
      "moveThere": "Премести там",
      "keep": "Остави",
      "close": "Прочетено",
      "approved": "Готово.",
      "rejected": "Отменено."
    },
    "change": {
      "placed": "Поставен.",
      "moved": "Преместен с {{metres}} м",
      "renamed": "сега {{line}}",
      "note": "променена бележка",
      "names": "променени имена",
      "stop": "променено място за спиране",
      "nothing": "Нищо не е променено."
    },
    "history": {
      "title": "История",
      "added": "Поставен",
      "changed": "Променен",
      "reported": "Отбелязан като грешен",
      "restored": "Върнат",
      "reportedSpot": "С мястото, където се е качил пътникът.",
      "answered": "отговорил {{name}} {{at}}",
      "restore": "Върни тази версия",
      "state": {
        "waiting": "чака",
        "approved": "одобрен",
        "rejected": "отхвърлен"
      }
    },
    "editor": {
      "addTitle": "Добави адрес",
      "editTitle": "Промени адреса",
      "find": "Намери сградата",
      "findHelp": "Картата се отваря върху нея; после щракнете всеки вход.",
      "findButton": "Намери",
      "nothingFound": "Нищо не е намерено.",
      "clickSets": "Щракване на картата поставя",
      "doorSet": "Входът е поставен.",
      "doorMissing": "Щракнете на картата там, където е входът.",
      "stopSet": "Колата спира другаде.",
      "stopAtDoor": "Колата спира пред входа.",
      "stopClear": "Да спира пред входа",
      "next": "Следващ вход",
      "delete": "Изтрий"
    },
    "list": {
      "title_one": "{{count}} адрес",
      "title_other": "{{count}} адреса",
      "filter": "Търси по адрес или име",
      "empty": "Още няма адреси. Добавете първия или оставете шофьорите да ги запомнят пред вратата.",
      "noMatch": "Нищо не съвпада.",
      "placedBy": "Поставил"
    },
    "import": {
      "open": "Качи CSV",
      "title": "Качи адреси",
      "about": "CSV поне с адреса и географските дължина и ширина на входа — както го дава „Изтегли CSV“. Нищо не се запазва, докато не добавите новите редове; адрес, който вече е тук, никога не се презаписва.",
      "row": "Ред",
      "status": "",
      "new": "нов",
      "conflict": "вече е тук",
      "invalid": "не може да се прочете",
      "add_one": "Добави {{count}} нов",
      "add_other": "Добави {{count}} нови",
      "done_one": "Добавен е {{count}} адрес.",
      "done_other": "Добавени са {{count}} адреса.",
      "noPoint": "Дължината и ширината не се четат — числа с точка, като 27.9147 и 43.2141.",
      "fileHint": "CSV, както го дава „Изтегли CSV“",
      "joinSimilar": "Обединявай подобни адреси",
      "joinSimilarHelp": "Изключено: „вече е тук“ е само адрес, написан със същите думи. Включено: адрес, чиито думи се съдържат в друг — „Бряст“ и „завод Бряст“ — се брои за същия и не се добавя. Адрес „зад“ или „отзад“ никога не е същият като предния."
    },
    "google": {
      "why": "Този адрес е от Google. Преди да го заключите като адрес на фирмата:",
      "name": "напишете го по свой начин",
      "pin": "преместете точката на самия вход"
    },
    "backToReport": "Обратно към справката",
    "alsoJoin": "Също присъедини {{orders}} и {{addresses}} от „{{line}}“",
    "joinExisting": "Присъедини към него",
    "joinedAfterSave": "Заключен „{{line}}“; присъединени {{orders}} и {{addresses}}.",
    "joins": {
      "title": "Присъединявания",
      "pending": "Недовършено",
      "finish": "Довърши",
      "undo": "Отмени",
      "undone": "отменено",
      "entry": "„{{typed}}“: {{orders}}, {{destinations}}, {{addresses}}",
      "finished": "Присъединяването е довършено.",
      "undoneNotice": "Присъединяването е отменено.",
      "row": "Присъединен адрес от отчета",
      "undoneBy": "отменено от {{name}} {{at}}"
    }
  },
  "labels": {
    "title": "Етикети",
    "help": "Диспечерът отбелязва етикет на поръчката, пътникът може да го поиска в приложението, и поръчката се предлага само на кола, която го има. Етикетът се изключва, а не се изтрива, защото колите и старите поръчки още го назовават.",
    "add": "Добави етикет",
    "none": "Фирмата още няма етикети.",
    "picture": "Снимка",
    "name": "Име",
    "shownToRiders": "В приложението за пътници",
    "shownToRidersOf": "Показвай „{{name}}“ в приложението за пътници",
    "shownToRidersHelp": "Пътниците могат да го поискат в приложението. Оставете го изключено за етикет, който се слага само от офиса.",
    "active": "Използва се",
    "activeOf": "„{{name}}“ се използва",
    "order": "Ред",
    "edit": "Промени",
    "editTitle": "{{name}}",
    "translated": "Показва се на езика на всеки читател, докато не го преименувате",
    "nameHelp": "Така, както ще го прочетат диспечерът и пътникът.",
    "nameStarterHelp": "Готовият етикет се показва на езика на всеки читател. Ако напишете други думи, той се преименува и всички четат вашите думи.",
    "pictureAfterAdding": "След като добавите етикета, можете да му сложите снимка.",
    "pictureHelp": "PNG, JPEG или WebP, до {{kb}} KB. Най-добре квадратна. Без снимка етикетът се показва само с думи.",
    "choosePicture": "Избери снимка…",
    "replacePicture": "Смени снимката…",
    "removePicture": "Премахни",
    "defaultPicture": "Върни снимката по подразбиране",
    "wordsAlone": "Само думи",
    "defaultMark": "по подразбиране",
    "switchedOff": "изключен",
    "switchedOffHelp": "„{{name}}“ е изключен. Показва се само защото е отбелязан, за да може да се махне."
  },
  "cancellations": {
    "title": "Причини",
    "help": "След „Отказ“ приложението за пътници предлага включените тук причини, в този ред, и после пита пътника дали е сигурен. Избраната причина се записва в историята на поръчката. Причината се изключва, а не се изтрива, защото старите поръчки още я назовават.",
    "add": "Добави причина",
    "none": "Фирмата още няма причини за отказ.",
    "name": "Причина",
    "active": "Предлага се",
    "activeOf": "Предлагай „{{name}}“",
    "order": "Ред",
    "rename": "Преименувай",
    "renameTitle": "Преименувай „{{name}}“",
    "translated": "Показва се на езика на всеки читател, докато не я преименувате",
    "nameHelp": "Така, както ще я прочете пътникът, с няколко думи.",
    "nameStarterHelp": "Готовата причина се показва на езика на всеки читател. Ако напишете други думи, тя се преименува и всички четат вашите думи."
  },
  "fileDrop": {
    "drop": "Пуснете файла тук",
    "release": "Пуснете, за да вземем този файл",
    "or": "или",
    "choose": "изберете от компютъра",
    "another": "изберете друг",
    "size": "{{size}} KB"
  },
  "devices": {
    "row": "Устройства",
    "label": "Номер",
    "labelHelp": "Както е написан на стикера, например „Т-07“. По него устройството се търси в списъка и в чекмеджето.",
    "kind": {
      "Phone": "Телефон",
      "Tablet": "Таблет"
    },
    "retirement": {
      "Broken": "Развалено",
      "Stolen": "Откраднато",
      "Lost": "Изгубено"
    },
    "list": {
      "title": "Устройства с улеснен достъп",
      "help": "Служебно устройство регистрирате само оттук. То остава тук: давате го на шофьор, взимате го обратно и го давате на следващия, докато не го отпишете. Личният телефон на шофьора е само негов — добавяте го от „Автопарк“ → „Устройства“ на шофьора или с одобрена заявка.",
      "register": "Регистрирай служебно устройство",
      "registerTitle": "Ново служебно устройство",
      "registerHelp": "Дайте му номер, после покажете QR кода. Сканирайте го от приложението на устройството: „Улеснен достъп“ → „Сканирай QR код от офиса“. Устройството остава свободно, докато не го дадете на шофьор.",
      "showQr": "Покажи QR кода",
      "kindFilter": "Вид",
      "allKinds": "Всички",
      "phones": "Телефони",
      "tablets": "Таблети",
      "statusFilter": "Състояние",
      "all": "Всички",
      "inUse": "В употреба",
      "free": "Свободни",
      "freeOne": "Свободно",
      "retired": "Отписани",
      "none": "Още няма устройства. Регистрирайте първото служебно с QR код.",
      "noneHere": "Няма устройства с тези филтри.",
      "kind": "Вид",
      "kindHelp": "Приложението го познава по размера на екрана. Поправете го, ако е сбъркало.",
      "model": "Модел",
      "state": "Състояние",
      "lastUsed": "Последно влизане",
      "never": "Още не",
      "give": "Дай на…",
      "giveTitle": "Дай {{device}} на шофьор",
      "giveHelp": "Устройството влиза само като този шофьор за няколко секунди. Без QR код: то вече е на фирмата.",
      "editTitle": "Промени {{device}}",
      "retire": "Отпиши",
      "retireTitle": "Отписване на {{device}}",
      "why": "Защо",
      "retireHelp": "Устройството спира веднага и повече не може да влезе. Остава в „Отписани“, за история.",
      "retireHelpInUse": "{{name}} излиза от него веднага. Устройството повече не може да влезе и остава в „Отписани“, за история.",
      "retiredOn": "отписано {{date}}",
      "lastWith": "последно у {{name}}",
      "delete": "Изтрий",
      "deleteTitle": "Да изтрия ли устройството?",
      "deleteHelp": "{{device}} изчезва от списъка заедно с историята си. Ако някога го регистрирате пак, ще е като ново.",
      "ownerFilter": "Чие е",
      "allOwners": "Всички",
      "firms": "Служебни",
      "personals": "Лични"
    },
    "unnamed": "Телефон без име",
    "close": "Затвори",
    "couldNotLoad": "Устройствата не можаха да се заредят.",
    "couldNotSave": "Промяната не беше запазена.",
    "banner": {
      "asked": "Заявка за улеснен достъп — код {{code}}",
      "open": "Отвори"
    },
    "approve": {
      "title": "Заявка за улеснен достъп",
      "asked": "поискано в {{time}}",
      "matchCode": "Проверете, че същият код е на екрана на телефона, или че шофьорът ви го прочете по телефона.",
      "whose": "Чий е телефонът",
      "existingDriver": "Шофьор от списъка",
      "newDriver": "Нов шофьор",
      "driver": "Шофьор",
      "pickDriver": "Изберете шофьор",
      "whichCar": "Кола",
      "existingCar": "Кола от списъка",
      "newCar": "Нова кола",
      "noCar": "Без кола",
      "car": "Кола",
      "carHelp": "Добавя се към колите, които шофьорът може да кара. Другите му остават.",
      "pickCar": "Изберете кола",
      "approve": "Одобри",
      "reject": "Откажи",
      "personalHelp": "Телефонът става личен телефон на шофьора: влиза само като него и не може да се дава на друг. Служебни устройства се регистрират от „Устройства“."
    },
    "dialog": {
      "title": "Устройства на {{name}}",
      "how": "Как влиза",
      "managed": "Акаунтът се управлява от офиса",
      "managedHelp": "Шофьорът влиза с улеснен достъп — QR код или заявка от телефона, без имейл и парола. Включено — всяка друга сесия на шофьора приключва веднага.",
      "alternate": "Може да ползва няколко устройства, едно по едно",
      "alternateOn": "Всяко негово устройство може да работи. Когато шофьорът натисне „Работя от този телефон“, другото спира.",
      "alternateOff": "Само едно устройство. Новото заменя старото, и старото спира.",
      "phones": "Устройства",
      "noPhones": "Още няма устройство. Дайте му служебно или добавете личния му телефон с QR код.",
      "addPhone": "Добави личен телефон с QR код",
      "neverUsed": "одобрен {{date}}, още не е влизал",
      "lastUsed": "последно влизане {{date}}",
      "release": "Освободи",
      "confirmReleaseTitle": "Да се освободи ли устройството?",
      "confirmRelease": "{{device}} се връща на фирмата като свободно. {{name}} излиза от него веднага. После го дайте на друг шофьор от „Устройства“.",
      "giveFree": "Дай служебно устройство",
      "give": "Дай",
      "keep": "Остави го",
      "replaces": "Шофьорът може да има само едно устройство: новото ще замени това. Служебното става свободно, а личният телефон се забравя.",
      "remove": "Премахни",
      "confirmRemoveTitle": "Да се премахне ли личният телефон?",
      "confirmRemove": "{{name}} излиза от {{device}} веднага и телефонът се забравя. За да влиза пак от него, добавете го отново с QR код или заявка."
    },
    "qr": {
      "alt": "QR код за личния телефон на шофьора",
      "help": "В приложението на шофьора: „Улеснен достъп“ → „Сканирай QR код от офиса“. Кодът важи 15 минути и само за един телефон.",
      "scanned": "Телефонът е регистриран и шофьорът е влязъл.",
      "lapsed": "Кодът изтече.",
      "again": "Нов код",
      "couldNotIssue": "QR кодът не можа да се създаде.",
      "registered": "Устройството е регистрирано и е свободно. Дайте го на шофьор от списъка."
    },
    "hire": {
      "how": "Как ще влиза",
      "byEmail": "С имейл и парола",
      "byDevice": "Улеснен достъп",
      "byDeviceHelp": "Без имейл. След като го запазите, ще видите QR код за личния му телефон. Служебно устройство му давате от „Дай служебно устройство“.",
      "done": "{{name}} е нает. Сканирайте QR кода с телефона му."
    },
    "owner": {
      "firm": "Служебно",
      "personal": "Лично"
    }
  }
}
